export default {
  default: "en",
  /////////////////// landig page ///////////////////
  landingpagetoolbar: {
    home: "Home",
    top_up: "Top Up",
    manual: "Manual",
    report: "Inform",
    shareholder: "Shareholder meeting",
    contact: "Contact",
    login: {
      title: "Login others service",
      portal: "Login Portal",
      package: "Login Package",
      eFactoring: "Service eFactoring",
      etax: "Login ETAX-SP",
      ePod: "Login E-Pod" // Login Transport
    },
    signup: {
      title: "Sign up",
      oneplatform: "Sign up Oneplatform",
      serviceetax: "Sign up Service e-Tax"
    },
    etax_invoice: {
      full: "e-Tax invoice",
      abb: "e-Tax invoice abb",
      dashbord: "Dashboard",
      report: "Report",
      report_setting: "Report setting",
      search_documents: "Search documents",
      search_documents_link: "Click to direct Search document page",
      instead: "Replacement documents",
      log: "Process log",
      email: "Email Relay Report"
    },
    logout: "Logout"
  },
  header: {
    title: "1st place",
    subTitle: "Electronic Tax Invoicing Service Provider",
    subTitle1: "Accredited by the Revenue Department",
    ref: "(Information as of September 1, 2022)"
  },
  footer: {
    provided: "Provided by",
    name_company_inet: "Internet Thailand Public Company Limited",
    address1_inet: "1768 Thai Summit Tower, Floor 10-12,IT New Petchaburi Road",
    address2_inet: " Khwaeng Bang Kapi, Khet Huay Khwang, Bangkok 10310",
    dealer: "Dealer",
    name_company_one: "One Electronic Billing Pub Co., Ltd.",
    address1_one: "1768 Thai Summit Tower, Floor 16 New Petchaburi Road",
    address2_one: " Khwaeng Bang Kapi, Khet Huay Khwang, Bangkok 10310",
    press3: "Press 3"
  },
  landingpage_som: {
    title: "Report usage etax proble",
    email: "Email",
    proble_topic: "Topic",
    detail: "Details",
    btn_confirm: "Confirm",
    btn_close: "Close",
    emailLabel: "Email address",
    emailCheck: "Please enter your email address.",
    topicCheck: "Please enter the issue title.",
    formatEmail: "Invalid email format",
    alertSuccess: "Successfully reported the problem. ",
    ref: "Reference number: ",
    alertFail:
      "Unable to open the problem report ticket because this email may not be registered in the SOM system.",
    alertCatch:
      "Unable to report problems at this time. Please try again later."
  },
  landingpage_attension: {
    title: "Contact for information e-Tax",
    name: "Fullname",
    tel: "Telephone ืumber",
    email: "Email",
    company: "Company",
    detail: "Details",
    btn_save: "Save",
    btn_del: "Clear",
    save_success: "Save data successfully",
    detail_save_success:
      "Your data has been received. Thank you for your interest in e-Tax",
    reEnterData: "Re-enter data",
    backHome: "Back to website",
    label_software: "Please input software currently in use",
    label_software_select: "Please select currently in use",
    softwareItems: [
      {
        text: "Express",
        value: "Express"
      },
      {
        text: "Peak Account",
        value: "PeakAccount"
      },
      {
        text: "BigWork",
        value: "BigWork"
      },
      {
        text: "Double M",
        value: "DoubleM"
      },
      {
        text: "Ada-Soft",
        value: "AdaSoft"
      },
      {
        text: "CD Organizer",
        value: "CDOrganizer"
      },
      {
        text: "Prosoft",
        value: "Prosoft"
      },
      {
        text: "etc.",
        value: "etc"
      }
    ],
    interestedPromotion: "Interest Promotion e-Tax Invoice",
    interestedPromotionDesc: "Promotion Description",
    interestedPromotionDescData: [
      {
        text: "Service Charge Free 6 Month",
        value: "Interest Promotion: Service Charge Free 6 Month"
      },
      {
        text: "Discount 50% 6 Month",
        value: "Interest Promotion: Discount 50% 6 Month"
      },
      {
        text: "Discount 25% 6 Month",
        value: "Interest Promotion: Discount 25% 6 Month"
      }
    ]
  },
  landingpage_ads: {
    detail:
      "This Web Portal system is a customized service for specific customers and is in the process of testing the system. Not in the conditions, scope of service and warranty of use of the INET e-Tax Service Provider service.",
    detail1: "Press the Agree Test button to accept the terms.",
    detail2: "or press not agree to test If you do not accept these conditions",
    btnAccept: "Accept",
    batNot: "or press not agree to test If you do not accept these conditions"
  },
  landingpage_shareholder: {
    title: "Shareholder meeting",
    subtitle: "Year Paper 2021",
    document: "Document"
  },
  landingpage_sendinvoice: {
    title: "Email (for sending Invoice)",
    btn_save: "Save data",
    rules: {
      rules_email: "Please enter your email address",
      rules_emailFix: "Invalid Email Format"
    }
  },
  /////////////////// webportal ///////////////////
  portaltoolbar: {
    home: "Profile",
    service: "Service",
    otp: {
      login: "Login with OTP",
      select: "Please select a channel for OTP.",
      note:
        "Note: OTP activation will be applied to all users using the same Tax ID number.",
      btnCancle: "Cancle",
      btnBtn: "Confirm",
      on: "OTP was successfully used.",
      open: "On",
      off: "Off"
    },
    login: {
      title: "Login others service",
      package: "Login Package",
      etax: "Login ETAX-SP"
    },
    admin: {
      title: "Logs Admin"
    },
    bill: {
      title: "Build Bill",
      list_create_etax: "Etax create list",
      create_etax: "Create E-tax",
      setting_number: "Setting document number",
      createCancleInstead: "Credit note",
      editTaxInvoice: "Edit document"
    },
    etax_invoice: {
      full: "e-Tax invoice",
      abb: "e-Tax invoice abb",
      dashbord: "Dashboard",
      report: "Report",
      ocr: "OCR",
      report_setting: "Report setting",
      search_documents: "Search documents",
      search_documents_link: "Click to direct Search document page",
      instead: "Replacement documents",
      log: "Process log",
      email: "Email relay Report",
      listemail: "Customer Email Information",
      logsendinvoicebyemail: "Logs send documents via email",
      title_revenue: "Sending revenue",
      revenue: "Send by period date",
      revenue_status: "Revenue status",
      delete_transaction: "Delete transaction",
      sentRevenuebyone: "Send by document"
    },
    logsusage: "Logs system usage",
    logsprintdocument: "Logs print document",
    top_up: "Top Up",
    manual: "Manual",
    report: "Inform",
    contact: "Contact",
    logout: "Logout",
    setting: "Setting",
    group_user: "Data Access Settings (Seller Branches)",
    sftp_confirm: "Confirm invoice system",
    taxbox: "Approve document",
    customize: "Special account",
  },
  searchdocument: {
    title: "Search documents",
    condition: {
      title: "Condition",
      detail_doc_date: "Dated document is the date specified in the document",
      detail_from_date:
        "Date of submission is the date the document is entered into the etax system",
      button_search: "Search",
      button_cler: "Clear",
      button_download: "Download",
      button_download_all: "All Document",
      button_download_aselect: "Selected Document",
      button_send_mail: "Send selected mail",
      button_resend: "Send mail",
      list_resend: [
        { text: "Send a separate email", value: "email_split" },
        { text: "Send a group email", value: "email_group" }
      ],
      condition_docid: "Document id",
      condition_todocid: "to",
      condition_doctype: "Document type",
      id: "ID",
      doctype_list: [
        { value: "", text: "All" },
        { value: "388", text: "Tax invoice" },
        { value: "T02", text: "Invoice/Tax invoice" },
        { value: "T03", text: "Bill/Tax invoice" },
        { value: "T04", text: "Delivery note/Tax invoice" },
        { value: "T01", text: "Bill" },
        { value: "T07", text: "Cancellation note" },
        { value: "T05", text: "ABB" },
        { value: "T06", text: "Receipt/Abbreviated Tax Invoice" },
        { value: "80", text: "Debit note" },
        { value: "81", text: "Credit note" },
        { value: "380", text: "Invoice" },
        { value: "383", text: "Dabit note" },
        { value: "381", text: "Credit note" },
        { value: "207", text: "Delivery Note" },
        { value: "325", text: "Performa Invoice" },
        { value: "623", text: "Forwarder’s Invoice" }
      ],
      condition_listdoc: "Document list",
      condition_listdocItem: [
        { value: "null", text: "All" },
        { value: "0", text: "General" },
        { value: "1", text: "Cancle/Out instead" }
      ],
      condition_seller_branchid: "Seller branch id",
      condition_buyer_taxid: "Buyer tax id",
      condition_buyer_name: "Buyer name",
      condition_buyer_branchid: "Buyer branch id",
      condition_fromdate: "Process date",
      condition_todate: "to",
      condition_processhint: "Please select document date",
      condition_fromdatedoc: "Document date",
      condition_todatedoc: "to",
      condition_close_dialog: "Close",
      condition_locale: "EN",
      condition_fromemail: "Send date",
      condition_toemail: "to",
      condition_status_email: "Status Email",
      waiting_for_delivery: "waiting for send"
    },
    detail: {
      doc_found: "Document found :",
      pdf: "PDF selected :",
      xml: "XML selected :"
    },
    table: {
      no: "No.",
      seller_branch: "Seller branch number",
      doc_type: "Document type",
      doc_id: "Document id",
      Process_date: "Process date",
      Document_date: "Document date",
      buyer: "Buyer",
      buyer_tax: "Tax id",
      buyer_name: "Name",
      buyer_branch: "Branch id",
      select_file: "Select file",
      resend_sms: "Send SMS",
      resend_onechat: "Send Onechat",
      resend_mail: "Send mail",
      resend_file: "Resend file",
      resend_mail_select: "Select",
      resend_mail_resend: "Resend",
      no_data: "No data"
    },
    dialog_email: {
      noemail_text1: "No email for sending file.",
      noemail_text2: "Enter an email",
      noemail_text3: "Need to add an email?",
      noemail_input: "Email",
      havemail_text1: "Send the file to",
      havemail_text2: "once again?",
      havemail_input: "Email",
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      loading: "Resendding...",
      complete: "Complete",
      btn_confirm: "Confirm",
      btn_edit: "Edit email",
      btn_add: "Add email"
    },
    dialog_download: {
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      notify_text1: "Downloading takes a long time. ",
      notify_text2: "Did you need to download?",
      btn_confirm: "Confirm",
      loading_download: "Downloading..."
    },
    swal: {
      specify: "Please specify conditions",
      notAlow: "Please add permission for using Group branch.",
      titleGroupBranch: "You do not have permission to access this menu.",
      subtitleGroupBranch: "Please contact your administrator to request access. You may share this link with them:",
      pathGroupBranch: "https://etax.one.th/portal/group-user",
      title:
        "The document is dated or the date the document was submitted. either",
      server_err:
        "The system is currently unavailable. Please contact the administrator",
      accesskey_err: "Accesskey is incorrect",
      download_err: "Could not download files",
      morefile_err: "Document have more than 1 file",
      information_err:
        "The information used for downloading the file could not be found.",
      user_no_found: "User ID not found",
      session: "Session expired",
      due_logged: "due to being logged in for too long",
      btn_cancle: "Cancle",
      btn_logout: "Logout",
      select_documents:
        "Please select the documents you wish to send by email.",
      check_pdf: "Please check the number of PDF files.",
      print_pdf: "Able to print PDF up to 100 files at a time.",
      select_pdf: "Please select a PDF file.",
      select_pdf_max: "Please select at least 1 PDF file, maximum 100 files.",
      print_err:
        "Unable to print PDF at this time (because PDF files cannot be opened)"
    }
  },
  deletetransaction: {
    title: "Delete transaction",
    condition: {
      title: "Condition",
      detail_doc_date: "Dated document is the date specified in the document",
      detail_from_date:
        "Date of submission is the date the document is entered into the etax system",
      button_search: "Search",
      button_cler: "Clear",
      button_download: "Download sample file",
      button_download_aselect: "Select import file",
      button_del: "Can be deleted",
      button_no_del: "Cant'n be deleted",
      detail_no_del:
        "Because the files have been sent to the Revenue Department.",
      order: "Item",
      condition_docid: "Document id",
      condition_todocid: "to",
      condition_doctype: "Document type",
      doctype_list: [
        { value: "", text: "All" },
        { value: "388", text: "Tax invoice" },
        { value: "T02", text: "Invoice/Tax invoice" },
        { value: "T03", text: "Bill/Tax invoice" },
        { value: "T04", text: "Delivery note/Tax invoice" },
        { value: "T01", text: "Bill" },
        { value: "T07", text: "Cancellation note" },
        { value: "T05", text: "ABB" },
        { value: "T06", text: "Receipt/Abbreviated Tax Invoice" },
        { value: "80", text: "Debit note" },
        { value: "81", text: "Credit note" },
        { value: "380", text: "Invoice" },
        { value: "383", text: "Dabit note" },
        { value: "381", text: "Credit note" },
        { value: "207", text: "Delivery Note" },
        { value: "325", text: "Performa Invoice" },
        { value: "623", text: "Forwarder’s Invoice" }
      ],
      condition_listdoc: "Document list",
      condition_listdocItem: [
        { value: "null", text: "All" },
        { value: "0", text: "General" },
        { value: "1", text: "Cancle/Out instead" }
      ],
      condition_seller_branchid: "Seller branch id",
      condition_buyer_taxid: "Buyer tax id",
      condition_buyer_name: "Buyer name",
      condition_buyer_branchid: "Buyer branch id",
      condition_fromdate: "Process date",
      condition_todate: "to",
      condition_processhint: "Please select document date",
      condition_fromdatedoc: "Document date",
      condition_todatedoc: "to",
      condition_close_dialog: "Close",
      condition_locale: "EN",
      condition_fromemail: "Send date",
      condition_toemail: "to",
      condition_status_email: "Status Email",
      waiting_for_delivery: "waiting for send",
      other: "Other"
    },
    detail: {
      doc_found: "Document found :",
      pdf: "PDF selected :",
      xml: "XML selected :"
    },
    table: {
      no: "No.",
      seller_branch: "Seller branch number",
      doc_type: "Document type",
      doc_id: "Document id",
      Process_date: "Process date",
      Document_date: "Document date",
      buyer: "Buyer",
      buyer_tax: "Tax id",
      buyer_name: "Name",
      buyer_branch: "Branch id",
      select_file: "Select file",
      resend_sms: "Send SMS",
      resend_onechat: "Send Onechat",
      resend_mail: "Send mail",
      resend_file: "Resend file",
      resend_mail_select: "Select",
      resend_mail_resend: "Resend",
      no_data: "No data",
      status_del: "Can be deleted",
      status_no_del: "Cannot delete",
      description: "Since the files have been sent to the Revenue Department",
      download: "Downloading..."
    },
    dialog: {
      title_text1: "Reason for requesting document deletion",
      title_text2: "List of documents to delete",
      title_text3: "*** OTP will be sent to email",
      title_text4: "Have you made a backup yet",
      title_text5:
        "Document deletion is still calculated for the tax invoice service.",
      title_text6: "Confirm actio?",
      title_text7:
        "Note: Deleting a document will not recover the document and deleted documents are assumed to be counted as 1 Transaction.",
      title_text8:
        "The electronically signed tax invoice is complete. Cannot be canceled To delete a document from the system Please back up your data in case it is checked later",
      title_input: "Position is Owner of Company and OTP is valid",
      subtitle_text1: "Deleting files",
      subtitle_text2: "Again?",
      subtitle_input: "minute",
      label_text1:
        "Please enter the reason for requesting the deletion of the document",
      label_text2: "Select excel file",
      label_text3: "Please enter email",
      success: "Yes",
      no_success: "No, continue",
      btn_confirm: "confirm",
      btn_cancle: "Cancel",
      btn_request: "Request OTP",
      confirmDelete: "Confirm document deletion",
      numDelete: "You want to delete a number of documents"
    },
    itemsList: [
      { tab: "List of documents found in the database" },
      { tab: "List of documents not found in the database" }
    ],
    swal: {
      otp_err: "Unable to request OTP",
      email_err: "No email information found on oneid.",
      server_err: "Unable to connect to server.",
      btn_confirm: "confirm",
      btn_cancle: "Cancel",
      success: "Success",
      fail: "failed",
      document_deleted: "The document has been deleted from the system.",
      session_expired: "The session has expired. Please login again",
      delete_document:
        "The document cannot be deleted at this time. Please contact the administrator"
    }
  },
  process_log: {
    condition: {
      title: "Condition",
      detail_doc_date: "Dated document is the date specified in the document",
      detail_from_date:
        "Date of submission is the date the document is entered into the etax system",
      button_search: "Search",
      button_cler: "Clear",
      button_excel: "Export EXCEL",
      button_download: "Download",
      button_download_all: "All Document",
      button_download_aselect: "Selected Document",
      button_send_mail: "Send selected mail",
      condition_docid: "Document id",
      condition_todocid: "to",
      condition_doctype: "Document type",
      other: "Other",
      doctype_list: [
        { value: "", text: "All" },
        { value: "388", text: "Tax invoice" },
        { value: "T02", text: "Invoice/Tax invoice" },
        { value: "T03", text: "Bill/Tax invoice" },
        { value: "T04", text: "Delivery note/Tax invoice" },
        { value: "T01", text: "Bill" },
        { value: "T07", text: "Cancellation note" },
        { value: "T05", text: "ABB" },
        { value: "T06", text: "Receipt/Abbreviated Tax Invoice" },
        { value: "80", text: "Debit note" },
        { value: "81", text: "Credit note" },
        { value: "380", text: "Invoice" },
        { value: "383", text: "Dabit note" },
        { value: "381", text: "Credit note" },
        { value: "207", text: "Delivery Note" },
        { value: "325", text: "Performa Invoice" },
        { value: "623", text: "Forwarder’s Invoice" }
      ],
      condition_listdoc: "Document list",
      condition_listdocItem: [
        { value: "null", text: "All" },
        { value: "0", text: "General" },
        { value: "1", text: "Cancle/Out instead" }
      ],
      process: [
        { text: "All(Success, Fail)", value: "null" },
        { text: "Success", value: "Y" },
        { text: "Fail", value: "Z" },
        { text: "deleted", value: "D" }
      ],
      condition_seller_branchid: "Seller branch id",
      condition_buyer_taxid: "Buyer tax id",
      condition_buyer_name: "Buyer name",
      condition_buyer_branchid: "Buyer branch id",
      condition_fromdate: "Process date",
      condition_todate: "to",
      condition_processhint: "Please select document date",
      condition_fromdatedoc: "Document date",
      condition_todatedoc: "to",
      condition_close_dialog: "Close",
      condition_locale: "EN",
      condition_fromemail: "Send date",
      condition_toemail: "to",
      condition_status_email: "Status Email",
      waiting_for_delivery: "waiting for send",
      condition_seller_contact: "Seller contact name"
    },
    detail: {
      doc_found: "Document found :",
      pdf: "PDF selected :",
      xml: "XML selected :"
    },
    table: {
      no: "No.",
      seller_branch: "Seller branch number",
      doc_type: "Document type",
      doc_id: "Document id",
      Process_date: "Process date",
      Document_date: "Document date",
      buyer: "Buyer",
      buyer_tax: "Tax id",
      buyer_name: "Name",
      buyer_branch: "Branch id",
      select_file: "Select file",
      resend_sms: "Send SMS",
      resend_onechat: "Send Onechat",
      resend_mail: "Send mail",
      resend_file: "Resend file",
      resend_mail_select: "Select",
      resend_mail_resend: "Resend",
      no_data: "No data"
    },
    dialog_email: {
      noemail_text1: "No email for sending file.",
      noemail_text2: "Enter an email",
      noemail_text3: "Need to add an email?",
      noemail_input: "Email",
      havemail_text1: "Send the file to",
      havemail_text2: "once again?",
      havemail_input: "Email",
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      loading: "Resendding...",
      complete: "Complete",
      btn_confirm: "Confirm",
      btn_edit: "Edit email",
      btn_add: "Add email"
    },
    dialog_download: {
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      notify_text1: "Downloading takes a long time. ",
      notify_text2: "Did you need to download?",
      btn_confirm: "Confirm",
      loading_download: "Downloading..."
    },
    swal: {
      specify: "Please specify conditions",
      title:
        "The document is dated or the date the document was submitted. either",
      server_err:
        "The system is currently unavailable. Please contact the administrator",
      accesskey_err: "Accesskey is incorrect",
      download_err: "Could not download files",
      morefile_err: "Document have more than 1 file",
      information_err:
        "The information used for downloading the file could not be found.",
      user_no_found: "User ID not found",
      session: "Session expired",
      due_logged: "due to being logged in for too long",
      btn_cancle: "Cancle",
      btn_logout: "Logout",
      select_documents:
        "Please select the documents you wish to send by email.",
      check_pdf: "Please check the number of PDF files.",
      print_pdf: "Able to print PDF up to 100 files at a time.",
      select_pdf: "Please select a PDF file.",
      select_pdf_max: "Please select at least 1 PDF file, maximum 100 files."
    },
    loading_search: "Loading...",
    btn_loadexcel: "Download excel",
    chip_success: "Success",
    chip_fail: "Fail",
    chip_delete: "Deleted",
    var_headers: [
      {
        text: "No.",
        align: "center",
        sortable: false,
        value: "no"
      },
      {
        text: "Document date",
        value: "document_date",
        sortable: false,
        align: "center"
      },
      {
        text: "Document ID",
        value: "document_id",
        sortable: false,
        align: "center"
      },
      {
        text: "Document type",
        value: "document_type_code",
        sortable: false,
        align: "center"
      },
      {
        text: "Service code",
        value: "service_code",
        sortable: false,
        align: "center"
      },
      {
        text: "Usercode",
        value: "user_code",
        sortable: false,
        align: "center"
      },
      {
        text: "Process date",
        value: "process_dtm",
        sortable: false,
        align: "center"
      },
      {
        text: "Status",
        value: "process_finish_ind",
        sortable: false,
        align: "center"
      },
      {
        text: "Error_message",
        value: "er_message",
        sortable: false,
        align: "center"
      },
      {
        text: "Seller contact name",
        value: "seller_contact_person_name",
        sortable: false,
        align: "center"
      },
      {
        text: "Document remark11",
        value: "document_remark11",
        sortable: false
      },
      {
        text: "Source system",
        value: "source_system",
        sortable: false
      },
      {
        text: "Document deletion date (username)",
        value: "delete_user",
        align: "center",
        sortable: false
      }
    ]
  },
  logsusage: {
    title: "Logs system usage",
    condition: {
      title: "Condition",
      button_search: "Search",
      button_cler: "Clear",
      button_excel: "Export Excel",
      button_download: "Download",
      button_download_all: "All Document",
      button_download_aselect: "Selected Document",
      condition_fromdate: "Date",
      condition_todate: "to",
      condition_processhint: "Please select document date",
      condition_close_dialog: "Close",
      condition_locale: "EN"
    },
    detail: {
      doc_found: "Document found :",
      pdf: "PDF selected :",
      xml: "XML selected :"
    },
    table: {
      no: "No.",
      date: "Date",
      status: "Status",
      status_success: "Success",
      status_fail: "Fail",
      no_data: "No data"
    },
    dialog_email: {
      noemail_text1: "No email for sending file.",
      noemail_text2: "Enter an email",
      noemail_text3: "Need to add an email?",
      noemail_input: "Email",
      havemail_text1: "Send the file to",
      havemail_text2: "once again?",
      havemail_input: "Email",
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      loading: "Resendding...",
      complete: "Complete",
      btn_confirm: "Confirm",
      btn_edit: "Edit email",
      btn_add: "Add email"
    },
    dialog_download: {
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      notify_text1: "Downloading takes a long time. ",
      notify_text2: "Did you need to download?",
      btn_confirm: "Confirm",
      loading_download: "Downloading..."
    },
    swal: {
      server_err:
        "The system is currently unavailable. Please contact the administrator",
      accesskey_err: "Accesskey is incorrect",
      download_err: "Could not download files",
      morefile_err: "Document have more than 1 file"
    }
  },
  logsprintdocument: {
    title: "Logs Print Document",
    success: "Success",
    fail: "Fail",
    loading_delete: "Deleting document...",
    condition: {
      title: "Condition",
      button_search: "Search",
      button_cler: "Clear",
      button_excel: "Export Excel",
      button_download: "Download",
      button_download_all: "All Document",
      button_download_aselect: "Selected Document",
      condition_fromdate_print: "Date of publication of the document",
      condition_todate_print: "to",
      condition_fromdate: "Process date",
      condition_todate: "to",
      condition_fromdatedoc: "Document date",
      condition_todatedoc: "to",
      condition_processhint: "Please select document date",
      condition_close_dialog: "Close",
      condition_locale: "EN",
      condition_docid: "Document id",
      condition_todocid: "to",
      condition_processid: "Process id",
      detail_print_date:
        "Date of publication of the document is the date specified to print the document.",
      detail_doc_date: "Dated document is the date specified in the document",
      seller_department: "Seller Department",
      seller_contact: "Seller Contact",
      seller_branchid: "Seller branch id",
      doctype: "Doucument type",
      buyer_taxid: "Buyer tax id",
      buyer_id: "Buyer id",
      buyer_name: "Name",
      buyer_branchid: "Buyer branch id",
      other: "other",
      doctype_list_all: [
        { value: "", text: "All" },
        { value: "380", text: "Invoice" },
        { value: "388", text: "Tax invoice" },
        { value: "T02", text: "Invoice/Tax invoice" },
        { value: "T03", text: "Bill/Tax invoice" },
        { value: "T04", text: "Delivery note/Tax invoice" },
        { value: "T01", text: "Bill" },
        { value: "80", text: "Debit note" },
        { value: "81", text: "Credit note" }
      ]
    },
    dialog_download: {
      loading_download: "Downloading..."
    },
    detail: {
      doc_found: "Document found :",
      pdf: "PDF selected :",
      xml: "XML selected :"
    },
    table: {
      no: "No.",
      date: "Date",
      status: "Status",
      no_data: "No data",
      document_id: "Document id",
      date: "Date",
      process_id: "Process id",
      seller_tax_id: "Tax ID Buyer",
      seller_branch_id: "Seller branch id",
      document_date: "Document date",
      document_type: "Document type",
      buyer_branch_id: "Buyer Branch ID",
      buyer_name: "Name",
      buyer_serial_no: "Buyer Tax ID",
      source_system: "Source system",
      status_ok: "Succeed",
      status_er: "Unsuccessful",
      status_desc: "Status description",
      print_date: "Print Date"
    },
    dialog_email: {
      noemail_text1: "No email for sending file.",
      noemail_text2: "Enter an email",
      noemail_text3: "Need to add an email?",
      noemail_input: "Email",
      havemail_text1: "Send the file to",
      havemail_text2: "once again?",
      havemail_input: "Email",
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      loading: "Resendding...",
      complete: "Complete",
      btn_confirm: "Confirm",
      btn_edit: "Edit email",
      btn_add: "Add email"
    },
    dialog_download: {
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      notify_text1: "Downloading takes a long time. ",
      notify_text2: "Did you need to download?",
      btn_confirm: "Confirm",
      loading_download: "Downloading..."
    },
    swal: {
      server_err: "Unable connect to server",
      accesskey_err: "Accesskey is incorrect",
      download_err: "Could not download files",
      morefile_err: "Document have more than 1 file",
      specify: "Please specify conditions",
      title: "Date of publication of the document or Dated documents"
    }
  },
  report: {
    title: "Report",
    condition: {
      title: "Condition",
      button_search: "Search Report",
      button_cler: "Clear",
      button_export_excel: "Export Excel",
      button_export_classification: "Classification documents",
      button_export_without: "without classifying documents",
      button_export_vat: "Sales tax details report",
      button_export_summary_vat: "Sales tax summary report",
      tabReceiptSummary: "Receipt Summary Report send and prepare tax invoices",
      seller_department: "Seller department",
      company: "Company name",
      condition_docid: "Document id",
      condition_todocid: "to",
      condition_doctype: "Document type",
      seller_department: "Seller department",
      doctype_list: [
        { value: "", text: "All" },
        // {value: '380' , text: 'Invoice'},
        { value: "388", text: "Tax invoice" },
        { value: "T02", text: "Invoice/Tax invoice" },
        { value: "T03", text: "Bill/Tax invoice" },
        { value: "T04", text: "Delivery note/Tax invoice" },
        { value: "T01", text: "Bill" },
        { value: "80", text: "Debit note" },
        { value: "81", text: "Credit note" }
      ],
      doctype_list_nosend: [
        { value: "", text: "All" },
        { value: "380", text: "Invoice" },
        { value: "383", text: "Dabit note" },
        { value: "381", text: "Credit note" },
        { value: "207", text: "Delivery Note" },
        { value: "325", text: "Performa Invoice" },
        { value: "623", text: "Forwarder’s Invoice" }
      ],
      doctype_list_all: [
        { value: "", text: "All" },
        { value: "388", text: "Tax invoice" },
        { value: "T02", text: "Invoice/Tax invoice" },
        { value: "T03", text: "Bill/Tax invoice" },
        { value: "T04", text: "Delivery note/Tax invoice" },
        { value: "T01", text: "Bill" },
        { value: "T07", text: "Cancellation note" },
        { value: "T05", text: "ABB" },
        { value: "T06", text: "Receipt/Abbreviated Tax Invoice" },
        { value: "80", text: "Debit note" },
        { value: "81", text: "Credit note" },
        { value: "380", text: "Invoice" },
        { value: "383", text: "Dabit note" },
        { value: "381", text: "Credit note" },
        { value: "207", text: "Delivery Note" },
        { value: "325", text: "Performa Invoice" },
        { value: "623", text: "Forwarder’s Invoice" }
      ],
      process: [
        { value: "null", text: "All" },
        { value: "Y", text: "Pass" },
        { value: "Z", text: "Not pass" }
      ],
      condition_venderSpilt: [
        { value: "S", text: "Show" },
        { value: "N", text: "Not show" }
      ],
      rdStatus: [
        { text: "All", value: "null" },
        { text: "Not yet delivered to the IRS", value: "N|A" },
        { text: "Prepare to deliver to the Revenue Department", value: "B" },
        { text: "Wait for a response from the Revenue Department", value: "W" },
        {
          text: "Successfully delivered to the Revenue Department",
          value: "R"
        },
        { text: "Failed to deliver to the IRS", value: "E" }
      ],
      filter_type_doc: [
        { text: "All", value: "all" },
        { text: "Deliver to the Revenue Department", value: "send" },
        { text: "Do not deliver to the IRS", value: "no_send" }
      ],
      items_tab: [
        { tab: "Document information" },
        { tab: "Total data by document" }
      ],
      tab_vender: "Total data by customer",
      condition_listdoc: "Document list",
      condition_listdocItem: [
        { value: "null", text: "All" },
        { value: "0", text: "General" },
        { value: "1", text: "Cancle/Out instead" }
      ],
      condition_seller_branchid: "Seller branch id",
      condition_buyer_taxid_head: "Tax ID",
      condition_buyer_branchid_head: "Branch ID",
      condition_buyer_taxid: "Buyer tax id",
      condition_buyer_name: "Buyer name",
      condition_buyer_branchid: "Buyer branch id",
      condition_fromdate: "Process date",
      condition_todate: "to",
      condition_processhint: "Please select document date",
      condition_fromdatedoc: "Document date",
      condition_todatedoc: "to",
      condition_close_dialog: "Close",
      condition_locale: "EN",
      condition_status_send: "status",
      condition_template: "Report Template",
      condition_select_template: "Please select a Report Template",
      condition_choose_document: "Choose a document format",
      condition_choose_customer: "Choose to show totals by customer",
      condition_select_template: "Please select a Report Template",
      condition_select_template: "Please select a Report Template",
      condition_select_template: "Please select a Report Template",
      detail_doc_date: "Dated document is the date specified in the document",
      detail_from_date:
        "Date of submission is the date the document is entered into the etax system",
      other: "Other",
      num_doc: "Number of documents",
      amount: "Amount",
      tax: "Tax-free",
      product_value: "Product value",
      service: "/service",
      tax_total_amount: "Tax total amount",
      grand_total_amount: "Grand total amount",
      wht_total_amount: "Wht total amount",
      actual_payment_total_amount: "Actual payment total amount",
      classified: "Classified by document type (excluding cancellation)",
      including: "Including documents (excluding cancellation)",
      release: "Classified by document type (Cancellation/Release)",
      include_release: "Include documents (Cancellation/Release)",
      all_documents: "Include all documents",
      customer_name: "Customer name"
    },
    detail: {
      doc_found: "Document found :",
      pdf: "PDF selected :",
      xml: "XML selected :"
    },
    table: {
      no: "No.",
      doc_type: "Document type",
      doc_id: "Document id",
      Process_date: "Process date",
      Document_date: "Document date",
      buyer: "Buyer",
      buyer_id: "Buyer id",
      buyer_tax: "Tax id",
      buyer_name: "Buyer name",
      buyer_branch: "Branch id",
      select_file: "Select file",
      resend_mail: "Resend mail",
      no_data: "No data",
      basis_amount_vat7: "Basis amount vat7%",
      tax_cal_amount_vat7: "Tax cal amount vat7%",
      basis_amount_vat0: "Basis amount vat0%",
      tax_cal_amount_vat0: "Tax cal amount vat0%",
      notax_total_amount: "Notax total amount",
      tax_basis_total_amount: "Tax basis total amount",
      tax_total_amount: "Tax total amount",
      grand_total_amount: "Grand total amount",
      wht_total_amount: "Wht total amount",
      actual_payment_total_amount: "Actual payment total amount",
      reason: "Reason for cancellation",
      reference_num: "Reference document number",
      reference_date: "Reference date",
      voucher_no: "Voucher no",
      status_send: "RD status",
      other: "Other",
      seller_branch_id: "Seller branch id",
      seller_department: "Seller department",

      status_type_doc: "This type of document is not sent to the IRS",
      status_not_delivered: "Not yet delivered to the IRS",
      status_prepare_deliver: "Prepare to deliver to the Revenue Department",
      status_wait_data: "Wait for a response from the Revenue Department.",
      status_success: "Successfully delivered to the Revenue Department",
      status_failed: "Failed to deliver to the IRS",
      status_process: "Processing",
      status_size: "The XML file size exceeds 3 MB.",
      month: "month",
      receivedItem: "Received Item",
      createdFailed: "The item created failed.",
      createdSuccess: "The item created success.",
      createdNext: "Dated document list that was created next month",
      createdPrevious:
        "Dated document list that were created the previous month",
      deliveredRevenue: "Items delivered to the Revenue Department",
      branchId: "Head office"
    },
    dialog_email: {
      noemail_text1: "No email for sending file.",
      noemail_text2: "Enter an email",
      noemail_text3: "Need to add an email?",
      noemail_input: "Email",
      havemail_text1: "Send the file to",
      havemail_text2: "once again?",
      havemail_input: "Email",
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      loading: "Resendding...",
      complete: "Complete",
      btn_confirm: "Confirm",
      btn_edit: "Edit email",
      btn_add: "Add email"
    },
    dialog_download: {
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      notify_text1: "Downloading takes a long time. ",
      notify_text2: "Did you need to download?",
      btn_confirm: "Confirm",
      loading_download: "Downloading..."
    },
    swal: {
      server_err:
        "The system is currently unavailable. Please contact the administrator",
      accesskey_err: "Accesskey is incorrect",
      download_err: "Could not download files",
      morefile_err: "Document have more than 1 file",
      download_report_err: "The report data could not be loaded",
      download_file_err: "The report file could not be downloaded"
    }
  },
  report_instead: {
    title: "Replacement documents",
    condition: {
      title: "Condition",
      button_search: "Search Report",
      button_cler: "Clear",
      button_export_excel: "Export Excel",
      button_export_classification: "Classification documents",
      button_export_without: "without classifying documents",
      company: "Company name",
      condition_docid: "Document id",
      condition_todocid: "to",
      condition_doctype: "Document type",
      condition_status_doc: "Document Status",
      items_status_doc: [
        { value: "", text: "all states" },
        { value: "PENDING", text: "Documents waiting" },
        { value: "REJECT", text: "Document fail" },
        { value: "SUCCESS", text: "Documents passed" }
      ],
      doctype_list: [
        { value: "", text: "All" },
        // {value: '380' , text: 'Invoice'},
        { value: "388", text: "Tax invoice" },
        { value: "T02", text: "Invoice/Tax invoice" },
        { value: "T03", text: "Bill/Tax invoice" },
        { value: "T04", text: "Delivery note/Tax invoice" },
        { value: "T01", text: "Bill" },
        { value: "80", text: "Debit note" },
        { value: "81", text: "Credit note" }
      ],
      doctype_list_nosend: [
        { value: "", text: "All" },
        { value: "380", text: "Invoice" },
        { value: "383", text: "Dabit note" },
        { value: "381", text: "Credit note" },
        { value: "207", text: "Delivery Note" },
        { value: "325", text: "Performa Invoice" },
        { value: "623", text: "Forwarder’s Invoice" }
      ],
      doctype_list_all: [
        { value: "", text: "All" },
        { value: "388", text: "Tax invoice" },
        { value: "T02", text: "Invoice/Tax invoice" },
        { value: "T03", text: "Bill/Tax invoice" },
        { value: "T04", text: "Delivery note/Tax invoice" },
        { value: "T01", text: "Bill" },
        { value: "T07", text: "Cancellation note" },
        { value: "T05", text: "ABB" },
        { value: "T06", text: "Receipt/Abbreviated Tax Invoice" },
        { value: "80", text: "Debit note" },
        { value: "81", text: "Credit note" },
        { value: "380", text: "Invoice" },
        { value: "383", text: "Dabit note" },
        { value: "381", text: "Credit note" },
        { value: "207", text: "Delivery Note" },
        { value: "325", text: "Performa Invoice" },
        { value: "623", text: "Forwarder’s Invoice" }
      ],
      process: [
        { value: "null", text: "All" },
        { value: "Y", text: "Pass" },
        { value: "Z", text: "Not pass" }
      ],
      condition_venderSpilt: [
        { value: "S", text: "Show" },
        { value: "N", text: "Not show" }
      ],
      rdStatus: [
        { text: "All", value: "null" },
        { text: "Not yet delivered to the IRS", value: "N|A" },
        { text: "Prepare to deliver to the Revenue Department", value: "B" },
        { text: "Wait for a response from the Revenue Department", value: "W" },
        {
          text: "Successfully delivered to the Revenue Department",
          value: "R"
        },
        { text: "Failed to deliver to the IRS", value: "E" }
      ],
      filter_type_doc: [
        { text: "All", value: "all" },
        { text: "Deliver to the Revenue Department", value: "send" },
        { text: "Do not deliver to the IRS", value: "no_send" }
      ],
      items_tab: [
        { tab: "Document information" },
        { tab: "Total data by document" }
      ],

      condition_listdoc: "Document list",
      condition_listdocItem: [
        { value: "null", text: "All" },
        { value: "0", text: "General" },
        { value: "1", text: "Cancle/Out instead" }
      ],
      condition_seller_branchid: "Seller branch id",
      condition_buyer_taxid: "Buyer tax id",
      condition_buyer_name: "Buyer name",
      condition_buyer_branchid: "Buyer branch id",
      condition_fromdate: "Process date",
      condition_todate: "to",
      condition_processhint: "Please select document date",
      condition_fromdatedoc: "Document date",
      condition_todatedoc: "to",
      condition_close_dialog: "Close",
      condition_locale: "EN",
      condition_status_send: "status",
      condition_template: "Report Template",
      condition_select_template: "Please select a Report Template",
      condition_choose_document: "Choose a document format",
      condition_choose_customer: "Choose to show totals by customer",
      condition_select_template: "Please select a Report Template",
      condition_select_template: "Please select a Report Template",
      condition_select_template: "Please select a Report Template",
      detail_doc_date: "Dated document is the date specified in the document",
      detail_from_date:
        "Date of submission is the date the document is entered into the etax system",
      other: "Other",
      num_doc: "Number of documents",
      amount: "Amount",
      tax: "Tax-free",
      product_value: "Product value",
      service: "/service",
      tax_total_amount: "Tax total amount",
      grand_total_amount: "Grand total amount",
      wht_total_amount: "Wht total amount",
      actual_payment_total_amount: "Actual payment total amount",
      classified: "Classified by document type (excluding cancellation)",
      including: "Including documents (excluding cancellation)",
      release: "Classified by document type (Cancellation/Release)",
      include_release: "Include documents (Cancellation/Release)",
      all_documents: "Include all documents",
      customer_name: "Customer name"
    },
    detail: {
      doc_found: "Document found :",
      pdf: "PDF selected :",
      xml: "XML selected :"
    },
    table: {
      no: "No.",
      doc_type: "Document type",
      doc_id: "Document id",
      Process_date: "Process date",
      Document_date: "Document date",
      buyer: "Buyer",
      buyer_id: "Buyer id",
      buyer_tax: "Tax id",
      buyer_name: "Buyer name",
      buyer_branch: "Branch id",
      select_file: "Select file",
      resend_mail: "Resend mail",
      no_data: "No data",
      documents_issued: "List of documents issued instead",
      seller_branch_id: "Seller branch id",
      no_issued: "Issue number",
      doc_date_issued: "Dated document instead of issue",
      doc_type_issued: "Document Type Issued Instead",
      date_issued: "The date the document was issued instead",
      seller_department: "Seller department"
    },
    dialog_email: {
      noemail_text1: "No email for sending file.",
      noemail_text2: "Enter an email",
      noemail_text3: "Need to add an email?",
      noemail_input: "Email",
      havemail_text1: "Send the file to",
      havemail_text2: "once again?",
      havemail_input: "Email",
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      loading: "Resendding...",
      complete: "Complete",
      btn_confirm: "Confirm",
      btn_edit: "Edit email",
      btn_add: "Add email"
    },
    dialog_download: {
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      notify_text1: "Downloading takes a long time. ",
      notify_text2: "Did you need to download?",
      btn_confirm: "Confirm",
      loading_download: "Downloading..."
    },
    swal: {
      server_err:
        "The system is currently unavailable. Please contact the administrator",
      accesskey_err: "Accesskey is incorrect",
      download_err: "Could not download files",
      morefile_err: "Document have more than 1 file",
      download_report_err: "The report data could not be loaded",
      download_file_err: "The report file could not be downloaded",
      specify: "Please specify conditions",
      title: "Document date or Process date was submitted. either",
      catch_err:
        "The system is currently unavailable. Please contact the administrator"
    }
  },
  revenue: {
    title: "Revenue",
    accesskey: "AccessKey",
    title1: "Check document send status",
    conditionTitle: "Conditions",
    btnCheck: "Check status",
    btnClear: "Clear data",
    no: "No.",
    docdate: "Document date",
    date: "Process date",
    rdDate: "Submission to RD date",
    docSend: "Documents sent",
    doctype: "Document type",
    sourceSystem: "Source system",
    conditionsRD: "Conditions for Revenue",
    success: "Sent successfully",
    fail: "Failed to send",
    wait: "Wait for a response from the RD",
    process: "Prepare to send",
    status: "Delivery Status to the RD",
    report: "Report",
    noData: "No data",
    statusN: "Not yet delivered to the IRS",
    statusP: "Processing",
    statusY: "File sent successfully",
    statusS: "The XML file size exceeds 3 MB.",
    statusZ: "Failed to deliver to the IRS",
    statusB: "Prepare to deliver to the RD",
    statusW: "Wait for a response from the RD",
    statusC: "Cert. Expired",
    reponseErr: "Unable to check status",
    notDefine: "Not specified",
    SendRevenueData: "Revenue submission date",
    title2: "Send documents to the Revenue Department",
    note: "Note",
    btnSend: "Send",
    detail: "Details of documents to be Sent",
    btnConfirmSend: "Confirmation of send",
    swalSuccess: "Process succeeded",
    numberInvoiceSend: "You want to send the number of documents",
    numberInvoiceSendTail: "?",
    btnCancle: "Cancle",
    btnConfimr: "Confirm",
    sentRevenue:
      "Documents during that time have been sent to the Revenue Department.",
    sentRevenueDone: "The invoice has been sent successfully.",
    sumTax: "VAT included",
    invoiceNum: "Number of invoices",
    invoiceNumUint: "sheet",
    mistake: "Mistake",
    refer:
      "Reference Announcement of the Director-General of the Revenue Department (No. 15)",
    titleCondition:
      "Subject defines rules, procedures and conditions for creating deliver and store electronic tax invoice and electronic receipts",
    dataEtaxMonth:
      " Article 15 The electronic tax invoice issuer or electronic receipt issuer is obliged to submit information related to the electronic tax invoice",
    orEtaxMonth:
      "or electronic receipt to the Revenue Department on a monthly basis through the Revenue Department's electronic system",
    onNextMonth: "By the 15th of the next month",
    contactEtax:
      "It will take approximately 3-7 days for the system to submit to the Revenue Department (depending on the number of documents and delivery time). Please contact us back at support@etax.one.th",
    delete_transaction: "Delete transaction",
    sentRevenuebyone: "Send to revenue (by document)",
    condition_send: "Condition",
    revenue_send_list: "Revenue send list",
    btnSendRevenue: "Revenue send",
    btnConfirmSendRevenue: "Confirm Revenue send",
    table: {
      no: "No.",
      documentId: "Document ID",
      status: "Status",
      errorMessage: "Note.",
      doc_date: "Document date",
      buyer_name: "Buyer Name",
      tax_id: "Tax ID Buyer",
      process_date: "Process date",
      document_date: "Document date",
      seller_branch: "Seller branch",
      document_name: "Document type",
      buyer_branch: "Buyer branch",
      statusResend: "Ready Revenue send"
    },
    tab_one: "Send by period date",
    tab_two: "Send by document",
    table_status_total: "Total ",
    table_status_unsend: "Unsent Documents",
    table_status_prepare: "Prepare delivery",
    table_status_work: "Waiting for a response from the Revenue Department",
    table_status_success: "Successful delivery",
    table_status_fail: "Delivery failed",
    table_status_3mb: "XML exceeds 3 MB"
  },
  profile: {
    setting: "General information",
    setting_access: "Set License",
    setting_group_branch: "Data access schedule (Seller branch)",
    setting_user: "General information (User)",
    setting_company: "General information (Company)",
    setting_service: "Setting Service SMS",
    status_active: "Available",
    status_no_active: "Not available",
    title: "Profile",
    name: "Username",
    company: "Company name",
    branch_id: "Branch ID",
    address: "Address",
    no: "No.",
    floor: "Floor",
    building: "Building",
    address_no: "No",
    address_road: "road",
    address_sub_district: "Sub district",
    address_district: "District",
    address_province: "Province",
    address_postal_code: "Postal code",
    address_moo_ban: "Village",
    address_moo_no: "Village No.",
    address_room_no: "Room No.",
    address_soi: "Soi",
    address_yaek: "Junction",
    title_revenue: "Sending revenue",
    send_revenue: "Send revenue",
    tax_id: "Tax ID",
    birthday: "Date of birth",
    email: "Email",
    modify: "modify",
    status: "Status",
    type: "Delivery type",
    details: "Details",
    regular_delivery: "Regular delivery",
    btn_save: "Save",
    btn_cancle: "Cancle",
    set_time: "Unable to specify time range 11:30 p.m. - 00:05 a.m.",
    name_company_thai: "Company name in Thai",
    name_company_eng: "Company name in English",
    send_time_1: "Can be delivered during that time",
    send_time_2:
      "During this period, revenue has been delivered as specified. Please select another time",
    send_time_3:
      "The system has set up the delivery of documents to the Revenue has failed. Please contact the administrator",
    swal: {
      notify_err: "Failed to load data",
      success: "success",
      mistake: "Error",
      setting_config: "Config set successfully",
      unable_setting_config: "Unable to set Config",
      incorrect_password: "Incorrect password",
      setting_sms: "Service SMS set successfully",
      unable_setting_sms: "Unable to set Service SMS"
    },
    checkUserNoteSuccess: "Can be delivered during that time.",
    checkUserNoteFull:
      "Such period has completed the tax remittance cycle as specified. Please select another time.",
    checkUserNoteFail:
      "The system has set up the delivery of documents to the Revenue Department. Please contact the administrator.",
    type_list: [
      { value: "send_time", text: "set time" },
      { value: "send_now", text: "send Etax" }
    ],
    set_date: "Set Date",
    days_no: [
      { value: "01", text: "01" },
      { value: "02", text: "02" },
      { value: "03", text: "03" },
      { value: "04", text: "04" },
      { value: "05", text: "05" },
      { value: "06", text: "06" },
      { value: "07", text: "07" },
      { value: "08", text: "08" },
      { value: "09", text: "09" },
      { value: "10", text: "10" },
      { value: "11", text: "11" },
      { value: "12", text: "12" },
      { value: "13", text: "13" },
      { value: "14", text: "14" },
      { value: "15", text: "15" },
      // { value: "16", text: "16" },
      // { value: "17", text: "17" },
      // { value: "18", text: "18" },
      // { value: "19", text: "19" },
      // { value: "20", text: "20" },
      // { value: "21", text: "21" },
      // { value: "22", text: "22" },
      // { value: "23", text: "23" },
      // { value: "24", text: "24" },
      // { value: "25", text: "25" },
      // { value: "26", text: "26" },
      // { value: "27", text: "27" },
      // { value: "28", text: "28" },
      // { value: "29", text: "29" },
      // { value: "30", text: "30" },
      // { value: "31", text: "31" },
    ],
    set_time_hour: "Set Time (hour)",
    time_hours: [
      { value: "00", text: "00" },
      { value: "01", text: "01" },
      { value: "02", text: "02" },
      { value: "03", text: "03" },
      { value: "04", text: "04" },
      { value: "05", text: "05" },
      { value: "06", text: "06" },
      { value: "07", text: "07" },
      { value: "08", text: "08" },
      { value: "09", text: "09" },
      { value: "10", text: "10" },
      { value: "11", text: "11" },
      { value: "12", text: "12" },
      { value: "13", text: "13" },
      { value: "14", text: "14" },
      { value: "15", text: "15" },
      { value: "16", text: "16" },
      { value: "17", text: "17" },
      { value: "18", text: "18" },
      { value: "19", text: "19" },
      { value: "20", text: "20" },
      { value: "21", text: "21" },
      { value: "22", text: "22" },
      { value: "23", text: "23" }
    ],
    set_time_minute: "Set Time (minute)",
    time_minute: [
      { value: "00", text: "00" },
      { value: "05", text: "05" },
      { value: "10", text: "10" },
      { value: "15", text: "15" },
      { value: "20", text: "20" },
      { value: "25", text: "25" },
      { value: "30", text: "30" },
      { value: "35", text: "35" },
      { value: "40", text: "40" },
      { value: "45", text: "45" },
      { value: "50", text: "50" },
      { value: "55", text: "55" }
    ],
    set_day: "Set Day",
    days: [
      { value: "mon", text: "Monday" },
      { value: "tue", text: "Tuesday" },
      { value: "wed", text: "Wednesday" },
      { value: "thu", text: "Thursday" },
      { value: "fri", text: "Friday" },
      { value: "sat", text: "Saturday" },
      { value: "sun", text: "Sunday" }
    ],
    time: "Time",
    send_day: "Send every day",
    of_each_month: "Of each month",
    send_every_day: "Every Day",
    send_every_week: "Every Week",
    send_every_month: "Every Month",
    set_config: "Setting format send revenue",
    dialog_confirm: "Confirm information",
    dialog_confirm_note_1:
      "Enabling/disabling the automatic delivery of IRS data Password storage is required to access the Token.",
    dialog_confirm_note_2: "do you want to continue ?",
    dialog_confirm_note_3:
      "Note: If the password is updated, it must be re-configured every time.",
    dialog_confirm_note_4:
      "Description: Can see Accesskey From the detailed documentation used to connect to the Service provided by INET",
    dialog_confirm_note_5:
      "Note: If the above information changes must be reset every time",
    file_input_password: "Please enter password"
  },
  settingLicense: {
    title: "Setting license",
    menu: "Menu",
    service: "service",
    btn_save: "save",
    btn_cancle: "Cancel",
    title_user: "User with access rights",
    access: "Role access",
    login: {
      title: "Login others service",
      package: "Login Package",
      etax: "Login ETAX-SP"
    },
    etax_invoice: {
      full: "e-Tax invoice",
      abb: "e-Tax invoice abb",
      dashbord: "Dashboard",
      report: "Report",
      ocr: "OCR",
      report_setting: "Report setting",
      search_documents: "Search documents",
      instead: "Replacement documents",
      log: "Process log",
      email: "Email relay Report",

      revenue: "Send revenue",
      revenue_status: "Revenue status",
      delete_transaction: "Delete transaction"
    },
    title_revenue: "Sending revenue",
    bill: {
      title: "Create Bill",
      list_create_etax: "Etax create list",
      create_etax: "Create E-tax",
      setting_number: "Setting document number",
      createCancleInstead: "Credit note",
      createCreditNote: "Create Credit Note",
      editTaxInvoice: "Edit document"
    },
    logsusage: "Logs system usage",
    logsprintdocument: "Logs print document",
    top_up: "Top Up",
    manual: "Manual",
    report: "Inform",
    contact: "Contact",
    logout: "Logout",
    itemsFullMenu: [
      { value: "dashbord", text: "Dashbord" },
      { value: "report", text: "Report" },
      { value: "report_setting", text: "Report settings" },
      { value: "search_documents", text: "Search documents" },
      { value: "instead", text: "Replacement documents" },
      { value: "processlog", text: "Process log" },
      { value: "email", text: "Email relay Report" },
      { value: "ocr", text: "OCR" },
      { value: "delete_transaction", text: "Delete transaction" }
    ],
    itemsAbbMenu: [
      { value: "dashbord", text: "Dashbord" },
      { value: "report", text: "Report" },
      { value: "report_setting", text: "Report settings" },
      { value: "search_documents", text: "Search documents" }
    ],
    etax_invoice: {
      full: "e-Tax invoice",
      abb: "e-Tax invoice abb"
    }
  },
  confirm: {
    title: "Confirm the remittance",
    condition: {
      title: "Condition",
      button_delivery: "Confirm",
      button_login: "Login",
      button_cancle: "Cancle",
      condition_fromdate: "Process date",
      condition_fromdatedoc: "Document date",
      condition_title_send: "Service sendEBXML is not working.",
      condition_subtitle: "Documents cannot be delivered during",
      condition_right_now: "Right now",
      condition_aleart:
        "You have successfully confirmed the send of the information.",
      condition_subaleart: "You have canceled .",
      condition_titleLogin: "Login to the Web Portal",
      condition_subtitleLogin: "to confirm the remittance"
    },
    detail: {
      num_doc: "number of documents",
      blade: "blade"
    },
    rules: {
      rules_username: "Please enter Username",
      rules_password: "Please enter Password",
      rules_taxid: "Please enter Tax ID",
      rules_numberFix: "Must be at least 13 digits"
    },
    swal: {
      mistake: "Mistake",
      server_err: "Please contact the administrator.",
      unavailable: "Currently unavailable"
    }
  },
  mailrelayreport: {
    title: "Email Relay Report",
    condition: {
      title: "Condition",
      button_search: "Search",
      button_cler: "Clear",
      button_excel: "Export EXCEL",
      button_download: "Download",
      button_download_all: "All Document",
      button_download_aselect: "Selected Document",
      detail_doc_date: "Dated document is the date specified in the document",
      detail_from_date:
        "Date of submission is the date the document is entered into the etax system",
      condition_docid: "Document id",
      condition_todocid: "to",
      condition_doctype: "Document type",
      condition_date_pressing: "Date of pressing send email again",
      other: "Other",
      tab_one: "Signing (send mail after signing)",
      tab_two: "Resend",
      tab_three: "Group mail",
      doctype_list: [
        { value: "", text: "All" },
        { value: "388", text: "Tax invoice" },
        { value: "T02", text: "Invoice/Tax invoice" },
        { value: "T03", text: "Bill/Tax invoice" },
        { value: "T04", text: "Delivery note/Tax invoice" },
        { value: "T01", text: "Bill" },
        { value: "T07", text: "Cancellation note" },
        { value: "T05", text: "ABB" },
        { value: "T06", text: "Receipt/Abbreviated Tax Invoice" },
        { value: "80", text: "Debit note" },
        { value: "81", text: "Credit note" },
        { value: "380", text: "Invoice" },
        { value: "383", text: "Dabit note" },
        { value: "381", text: "Credit note" },
        { value: "207", text: "Delivery Note" },
        { value: "325", text: "Performa Invoice" },
        { value: "623", text: "Forwarder’s Invoice" }
      ],
      condition_listdoc: "Document list",
      condition_listdocItem: [
        { value: "null", text: "All" },
        { value: "0", text: "General" },
        { value: "1", text: "Cancle/Out instead" }
      ],
      condition_seller_branchid: "Seller branch id",
      condition_buyer_taxid: "Buyer tax id",
      condition_buyer_name: "Buyer name",
      condition_buyer_branchid: "Buyer branch id",
      condition_fromdate: "Process date",
      condition_todate: "to",
      condition_processhint: "Please select document date",
      condition_fromdatedoc: "Document date",
      condition_todatedoc: "to",
      condition_close_dialog: "Close",
      condition_locale: "EN",
      condition_fromemail: "Send date",
      condition_toemail: "to",
      condition_status_email: "Status Email",
      condition_fromdatemail: "Email resend date",
      condition_todatemail: "to",
      send_system: [
        { text: "All", value: "" },
        { text: "Signing", value: "signdocument" },
        { text: "Resend", value: "resend" }
      ],
      condition_test_system: "Email send type"
    },
    detail: {
      doc_found: "Document found :",
      pdf: "PDF selected :",
      xml: "XML selected :"
    },
    table: {
      no: "No.",
      doc_id: "Document id",
      status_email: "Status email",
      document_type: "Document type",
      list_data: "List Email relay Report",
      email_from: "Sender email",
      email_to: "Recipient email",
      detail: "Detail",
      timestamp: "Timestamp",
      status_email_send: "Status send email",
      read: "Read/Count",
      user_resend: "Resend By",
      status_process_email_send: "Status process send email",
      select_file: "Select file",
      description: "Description",
      tax_id: "Tax ID Buyer",
      buyer_name: "Buyer name",
      resend_mail: "Resend mail",
      message: "Message id",
      no_data: "No data",
      seller_department: "Seller department",
      document_date: "Document date",
      status: "Status",
      file_size: "File size",
      err_message: "Note"
    },
    dialog_email: {
      noemail_text1: "No email for sending file.",
      noemail_text2: "Enter an email",
      noemail_text3: "Need to add an email?",
      noemail_input: "Email",
      havemail_text1: "Send the file to",
      havemail_text2: "once again?",
      havemail_text3: "Email sent last time",
      havemail_text4: "Email in Database",
      havemail_text5: "New Email",
      havemail_input: "Email",
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      loading: "Resendding...",
      complete: "Complete",
      btn_confirm: "Confirm",
      btn_edit: "Edit email",
      btn_add: "Add email"
    },
    dialog_download: {
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      notify_text1: "Downloading takes a long time. ",
      notify_text2: "Did you need to download?",
      btn_confirm: "Confirm",
      loading_download: "Downloading..."
    },
    swal: {
      server_err:
        "The system is currently unavailable. Please contact the administrator",
      accesskey_err: "Accesskey is incorrect",
      download_err: "Could not download files",
      morefile_err: "Document have more than 1 file",
      data_download_err: "Downloading takes a long time.",
      notify_download_excel: "Did you need to download?",
      notify_email_err:
        "The document was not found in the system. used for sending duplicate emails",
      title_token: "Token ONE Expires",
      subtitle_token: "Please login again to refresh the token",
      btn_cancle: "Cancle",
      btn_logout: "Logout",
      alert_specify: "Please specify conditions",
      docdate_resendate: "Dated document range or resend date range either"
    },
    dialog_group_email: {
      title: "More details",
      close: "Close"
    }
  },
  resendmail: {
    title: "Email Relay Report",
    condition: {
      title: "Condition",
      button_search: "Search",
      button_cler: "Clear",
      button_excel: "Export EXCEL",
      button_download: "Download",
      button_download_all: "All Document",
      button_download_aselect: "Selected Document",
      detail_doc_date: "Dated document is the date specified in the document",
      detail_from_date:
        "Date of submission is the date the document is entered into the etax system",
      condition_docid: "Document id",
      condition_todocid: "to",
      condition_doctype: "Document type",
      condition_date_pressing: "Date of pressing send email again",
      other: "Other",
      num: "number",
      order: "Item",

      doctype_list: [
        { value: "", text: "All" },
        { value: "388", text: "Tax invoice" },
        { value: "T02", text: "Invoice/Tax invoice" },
        { value: "T03", text: "Bill/Tax invoice" },
        { value: "T04", text: "Delivery note/Tax invoice" },
        { value: "T01", text: "Bill" },
        { value: "T07", text: "Cancellation note" },
        { value: "T05", text: "ABB" },
        { value: "T06", text: "Receipt/Abbreviated Tax Invoice" },
        { value: "80", text: "Debit note" },
        { value: "81", text: "Credit note" },
        { value: "380", text: "Invoice" },
        { value: "383", text: "Dabit note" },
        { value: "381", text: "Credit note" },
        { value: "207", text: "Delivery Note" },
        { value: "325", text: "Performa Invoice" },
        { value: "623", text: "Forwarder’s Invoice" }
      ],
      condition_listdoc: "Document list",
      condition_listdocItem: [
        { value: "null", text: "All" },
        { value: "0", text: "General" },
        { value: "1", text: "Cancle/Out instead" }
      ],
      condition_seller_branchid: "Seller branch id",
      condition_buyer_taxid: "Buyer tax id",
      condition_buyer_name: "Buyer name",
      condition_buyer_branchid: "Buyer branch id",
      condition_fromdate: "Process date",
      condition_todate: "to",
      condition_processhint: "Please select document date",
      condition_fromdatedoc: "Document date",
      condition_todatedoc: "to",
      condition_close_dialog: "Close",
      condition_locale: "EN",
      condition_fromemail: "Send date",
      condition_toemail: "to",
      condition_status_email: "Status Email",
      condition_fromdatemail: "Email resend date",
      condition_todatemail: "to"
    },
    detail: {
      doc_found: "Document found :",
      pdf: "PDF selected :",
      xml: "XML selected :"
    },
    table: {
      no: "No.",
      doc_id: "Document id",
      status_email: "Status email",
      document_type: "Document type",
      list_data: "List Email relay Report",
      email_from: "Sender email",
      email_to: "Recipient email",
      timestamp: "Timestamp",
      status_email_send: "Status send email",
      read: "Read/Count",
      user_resend: "Resend By",
      status_process_email_send: "Status process send email",
      select_file: "Select file",
      description: "Description",
      tax_id: "Tax ID Buyer",
      buyer_name: "Buyer name",
      resend_mail: "Resend mail",
      message: "Message id",
      no_data: "No data"
    },
    dialog_email: {
      noemail_text1: "No email for sending file.",
      noemail_text2: "Enter an email",
      noemail_text3: "Need to add an email?",
      noemail_input: "Email",
      havemail_text1: "Send the file to",
      havemail_text2: "once again?",
      havemail_text3: "Email sent last time",
      havemail_text4: "Email in Database",
      havemail_text5: "New Email",
      havemail_input: "Email",
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      loading: "Resendding...",
      complete: "Complete",
      btn_confirm: "Confirm",
      btn_edit: "Edit email",
      btn_add: "Add email"
    },
    dialog_download: {
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      notify_text1: "Downloading takes a long time. ",
      notify_text2: "Did you need to download?",
      btn_confirm: "Confirm",
      loading_download: "Downloading..."
    },
    swal: {
      server_err:
        "The system is currently unavailable. Please contact the administrator",
      accesskey_err: "Accesskey is incorrect",
      download_err: "Could not download files",
      morefile_err: "Document have more than 1 file",
      data_download_err: "Downloading takes a long time.",
      notify_download_excel: "Did you need to download?",
      notify_email_err:
        "The document was not found in the system. used for sending duplicate emails",
      title_token: "Token ONE Expires",
      subtitle_token: "Please login again to refresh the token",
      btn_cancle: "Cancle",
      btn_logout: "Logout"
    }
  },
  dialog_download: {
    accesskey_text1: "Enter an accesskey",
    accesskey_text2: "Note: accesskey expires in 15 minute",
    notify_text1: "Downloading takes a long time. ",
    notify_text2: "Did you need to download?",
    btn_confirm: "Confirm",
    loading_download: "Downloading..."
  },
  swal: {
    server_err:
      "The system is currently unavailable. Please contact the administrator",
    accesskey_err: "Accesskey is incorrect",
    download_err: "Could not download files",
    morefile_err: "Document have more than 1 file",
    data_download_err: "Downloading takes a long time.",
    notify_download_excel: "Did you need to download?"
  },
  dashbord: {
    title: "Dashboard",
    numOfDoc: "Total Documents Amount",
    storageAll: "Storage Usage",
    billCurentMount: "Current Mounth Transaction ",
    billPerMonth: "Document per month",
    billPerHour: "Document per hour",
    packages: "Package Info",
    package: "Package",
    select: "Select",
    close: "Close",
    storageOfMonth: "Storage Usage In ",
    transactionInMonth: "Transactions Usage In",
    transactionSuccess: "Success Transaction",
    transactionFail: "Failed Transaction",
    transactionDel: "Deleted Transaction",
    transactionAll: "Total Transaction",
    transactionPerMounth: "Transaction Per Mounth",
    textAlert: "The system will update every midnight of the next day"
  },
  report_setting: {
    title: "Report Settings",
    manage_temp: "Manage Templates",
    add_temp: "Add Template",
    edit_temp: "Edit Template",
    report_temp: "Report Template",
    delete_temp: "Delete Template",
    report_data: "Report data",
    default: "default",
    sample: "Sample report",
    name_temp_rule: "Please name Template",
    name_temp: "Name Template",
    create_temp: "Create Template",
    save_temp: "Save Template Data",
    btn_save: "Confirm",
    btn_cancle: "Cancle",
    swal: {
      name_err: "Please name the Template you want to create.",
      data_report_err: "Cannot set more than 13 columns of report data.",
      create_success: "Report Template created successfully",
      create_err: "Could not create Report Template at this time.",
      report_err: "Unable to select more than 13 report data.",
      edit_temp: "Edit Template",
      success: "Done",
      temp_err: "The Report Template cannot be edited at this time.",
      delete_default: "Cannot delete Template Default",
      delete_title: "You want to delete the Template ",
      or: "or not",
      delete_success: "The report template has been deleted.",
      delete_err: "The Template cannot be deleted at this time."
    }
  },
  keydetail: {
    details: "Details",
    general: "General Info",
    filename: "File name",
    filesize: "File size",
    filetype: "File type",
    filedate: "Upload date",
    closeDialog: "close",
    owner: "Owner",
    month: {
      jan: "Jan",
      feb: "Feb",
      mar: "Mar",
      apr: "Apr",
      may: "May",
      jun: "Jun",
      jul: "Jul",
      aug: "Aug",
      sep: "Sep",
      oct: "Oct",
      nov: "Nov",
      dec: "Dec"
    }
  },
  resendmaillog: {
    header_table: {
      buyer_serial_no: "Buyer Tax ID",
      buyer_branch_id: "Buyer Branch ID",
      buyer_name: "Buyer Name",
      document_id: "Document ID",
      document_date: "Document Date",
      process_dtm: "Process DTM",
      email_from: "Seller Email",
      email_to: "Buyer Email",
      type_code: "Document Type",
      status_onebox: "Status (OneBox)",
      status: "Status (Email)",
      resentmail: "Resendmail"
    }
  },
  create_bill: {
    title: "Create bill list",
    btn_create_invoice: "Create document",
    condition: {
      title: "Search conditions",
      condition_issue_date: "Document date",
      condition_toissuedate: "To",
      condition_status: "Status",
      condition_status_list: [
        { value: "", text: "All" },
        // {value: '-1', text: 'Reject'},
        { value: "0", text: "Draft" },
        // {value: '1', text: 'Waiting payment'},
        // {value: '2', text: 'waiting check'},
        // {value: '3', text: 'Payment complete'},
        { value: "4", text: "Successful document creation" }
      ],
      condition_status_update: [
        { value: "-1", text: "Reject" },
        { value: "0", text: "Draft" },
        { value: "1", text: "Waiting payment" },
        { value: "2", text: "waiting check" },
        { value: "3", text: "Payment complete" }
      ],
      condition_search: "Document id, Buyer name, Total price ",
      condition_close_dialog: "Close",
      condition_locale: "EN",
      time: "Time",
      condition_search_up: "Advanced search"
    },
    detail: {
      doc_found: "Number of documents found :"
    },
    table: {
      header_no: "No.",
      header_doc_type: "Document type",
      header_doc_id: "Document id",
      header_buyer_name: "Buyer name",
      header_tax_basis_total_amount: "Tax basis total amount",
      header_vat: "Tax total amount",
      header_grand_total: "Grand total amount",
      header_grand_total: "Total price (baht)",
      header_document_dtm: "Document date",
      header_etx_dtm: "Document create date",
      header_status: "Status",
      header_user_create: "User create"
    },
    dowloadind_data: "Downloading data ...",
    swal: {
      server_err:
        "The system is currently unavailable. Please contact the administrator",
      data_download_err: "Downloading takes a long time.",
      notify_download_excel: "Did you need to download?",
      no_data: "No data found in the system.",
      old_document:
        "because it is an old document in the system Before updating the billing menu",
      old_download: "Unable to download document",
      old_view: "Unable to view document",
      old_del: "Unable to delete document",
      rd_sent: "documents is already sent to RD"
    },
  },
  create_invoice: {
    title: "Create document",
    title_buyer_info: "Buyer information",
    title_dialog: "Confirm document creation",
    sub_title_dialog:
      "Please check the information before creating. Because if the document has already been created, it cannot be edited. proceed to create leaves ",
    orNot: " or not ?",
    note_dialog:
      " Note: Please enter Usercode and Accesskey for first time document creation.",
    button_home: "back to main",
    chip_cancle: "Cancel",
    chip_draft: "Draft",
    chip_pending_payment: "pending payment",
    chip_waiting_review: "Failed to create document",
    chip_paid: "Inprogress",
    chip_success: "Success",
    btnAddContact: "New Buyer",
    btnSearch: "Search from RD",
    nameCompany: "Company/Name (Buyer name)",
    titleSearch: "Search from the Revenue Department's",
    btnSearchRD: "Search from RD",
    btnSearchData: "Search",
    lableTaxid: "Type a Tax ID",
    labelBuyerSearch: "Fill in the buyer's name, Tax id, email, phone number",
    otp: "Invalid OTP",
    noteEmail: "* Specify an e-mail if you want to send e-mail ",
    noteSubEmail: "and use a comma(,) separator for multiple emails.",
    pleaseSelect: "Please select",
    pleaseSelectSalesType: "Please select a sales type",
    tableSearch: {
      taxid: "Tax ID",
      nameCom: "Company Name",
      branchId: "Branch number",
      address: "address",
      action: "Options",
      select: "Select"
    },
    condition: {
      title: "Document information",
      sub_title: "Invoice information",
      button_add_product: "Add products / services",
      button_vat: "Withholding tax",
      button_add_receiving: "Add a receiving account",
      button_upload_file: "Upload files",
      button_preview_pdf: "Preview PDF",
      button_create: "Create",
      now: " now",
      button_save: "Save draft",
      button_saveAndCreate: "Save and Create ",
      button_send: "Send invoice",
      button_cancle: "Cancle",
      button_confirm: "Confirm",
      condition_buyer_name: "Buyer name",
      condition_branchid: "Branch id",
      condition_taxid: "Tax id",
      condition_address: "Address",
      condition_address_no: "No",
      condition_address_road: "road",
      condition_address_sub_district: "Sub district",
      condition_address_district: "District",
      condition_address_thambol: "Sub district",
      condition_address_amphur: "District",
      condition_address_province: "Province",
      condition_address_postal_code: "Postal code",
      condition_address_tel: "Tel",
      condition_address_name_contact: "Name contact",
      condition_invoice_id: "Invoice id",
      condition_doc_id: "Document id",
      condition_required: "* Required",
      condition_issue_date: "Document date",
      rule_issue_date: "Pleace select Issue date",
      condition_doc_type: "Document type",
      condition_example: "Example: monthly fee",
      condition_listproduct: "Product / Service List",
      condition_listproductItem: [
        { value: "0", text: "Separate tax" },
        { value: "1", text: "Tax included" }
      ],
      condition_close_dialog: "Close",
      condition_locale: "EN",
      condition_total_money: "Basis amount",
      condition_total: "Basis amount (Baht)",
      condition_discount_included: "Discount included",
      condition_price_discount: "Price after discount",
      condition_value_without_tax: "Value without tax / exemption",
      condition_taxable: "Tax basis total amount",
      condition_vat: "Tax total amount",
      condition_total_sum: "Grand total amount",
      condition_payment_channel: "Payment channel",
      condition_additional_information: "Additional information",
      condition_additional_notes: "Additional Notes",
      condition_more_options: "More options",
      condition_barcode_bank: "Barcode bank payment",
      condition_without_tax: "Withholding",
      condition_amount_paid: "Amount to be paid",
      condition_attachment: "Attachment",
      condition_uploaded_file:
        "The uploaded file must not exceed 5 MB in size.",
      condition_tooltip:
        "If your receiving account has a Bill Paymenyt with the bank. ",
      condition_edm: "Display message electronic document management",
      condition_sub_tooltip:
        "You can turn on this function to generate barcodes for payments into PDFs.",
      condition_rule_documentId: "Please enter document id",
      condition_rule_documentType: "Please enter a document type",
      condition_rule_detailProduct: "Please enter product details",
      condition_rule_amount: "Please enter quantity",
      condition_rule_price: "Please enter price/unit",
      condition_rule_discount: "Please enter discount",
      condition_rule_tax: "Select tax",
      select_discount: "Type Discount",
      rule_issue_date: "Pleace select Issue date",
      reason_delete: "Reason for deletion of documents",
      condition_creditNoteTitle:
        "Information for issuing a credit note / credit note",
      condition_docIdOld: "Old document number",
      condition_docDate: "Reference Date",
      condition_docType: "Reference Type",
      condition_docNoteCode: "Debt Reduction Reason Code",
      condition_docNote: "Reason for reducing debt",
      condition_docValue: "Adjusted information amount",
      condition_additional_ref: "Additional reference",
      condition_note: "Reason for reference",
      condition_detail: "Details (in case other reasons are selected)",
      condition_rule_note: "Please specify the reason for the reference.",
      condition_rule_docIdOld: "Please enter the original document number.",
      condition_rule_docDate: "Please enter the reference date.",
      condition_rule_docType: "Please enter the reference type.",
      condition_rule_docNote: "Please enter the reason for the debt reduction.",
      condition_rule_docNoteCode: "Please enter Reason for Debt Reduction Code",
      condition_rule_docValue: "Please enter Adjusted information amount",

      condition_additional_informationRule:
        "Please enter up to 500 additional characters.",
      condition_productNameRule:
        "Please enter product details up to 256 characters.",
      condition_rule_po_number:
        "Please specify Purchase Order Number",
      condition_rule_rtv_number: "Please specify RTV Number",
      condition_select_send: "Delivery method as specified",
      condition_select_one: "(Only one channel can be selected)",
      condition_channel: "Additional information delivery channel",
      condition_send_doc: "*When selected, the system will send documents via",
      condition_auto: "automatically",
      condition_rule_note_no: "Please specify the Return Note No.",
    },
    dialog: {
      title: "Add a payment method",
      account_type: "Account type",
      confirm_delete: "Confirm delete of buyer information",
      dialogRef:
        "Specifying reference documents The system will not check whether the information actually exists or not. Confirm that the source reference information is correct or not ?",
      listaccountItem: [
        { value: "promptpay", text: "Scan QR through PromptPay account." },
        { value: "bank", text: "Bank transfer" }
      ],
      bankItems: [
        {
          value: "kk",
          name: "Kiatnakin Bank",
          image: require("@/assets/img/icon-bank/kiatnakin.png")
        },
        {
          value: "scb",
          name: "Siam Commercial Bank",
          image: require("@/assets/img/icon-bank/scb.png")
        },
        {
          value: "kbank",
          name: "Kasikorn Bank",
          image: require("@/assets/img/icon-bank/kbank.png")
        },
        {
          value: "ktb",
          name: "Krung Thai Bank",
          image: require("@/assets/img/icon-bank/krungthai.png")
        },
        {
          value: "bbl",
          name: "Bangkok Bank",
          image: require("@/assets/img/icon-bank/bangkok.png")
        },
        {
          value: "bay",
          name: "Bank of Ayudhya ",
          image: require("@/assets/img/icon-bank/krungsri.png")
        },
        {
          value: "gsb",
          name: "Government Savings bank",
          image: require("@/assets/img/icon-bank/aomsin.png")
        },
        {
          value: "tbank",
          name: "Thanachart Bank ",
          image: require("@/assets/img/icon-bank/tnc.png")
        },
        {
          value: "tmb",
          name: "TMB Bank ",
          image: require("@/assets/img/icon-bank/tmb.png")
        },
        {
          value: "uob",
          name: "United Overseas Bank",
          image: require("@/assets/img/icon-bank/uob.png")
        },
        {
          value: "sme",
          name: "Small and Medium Enterprise Development Bank of Thailand",
          image: require("@/assets/img/icon-bank/unnamed.png")
        }
      ],
      sub_title:
        "The system will generate a QR Code and attach it to the bill that has been sent. Find customers through Email , allowing customers to scan for payment.",
      promptpay_number: "PromptPay number",
      account_name: "Account name",
      bank_name: "Bank",
      account_number: "Account number",
      explain: "For the item you wish to pay by check Or cash only",
      button_add: "Add",
      button_cancle: "Cancle",
      note_email:
        "Note: Mak like for this document to be delivered directly to the target and more than 1 check mark to the device, between the pages"
    },
    dialogBuyername: {
      title: "Buyer information",
      contactData: "Contact information",
      sellerid: "Seller Tax Id",
      sub_title: "Buyer address",
      button_save: "Save",
      button_close: "Close",
      button_add: "Add buyer information",
      button_edit: "Edit",
      button_delete: "Delete",
      business_type: "Type of business",
      juristic_person: "Juristic person",
      guest: "Guest",
      passport: "Passport",
      other: "Other",
      buyer_name: "Buyer name",
      branchid: "Branch id",
      taxid: "Tax id",
      taxid_tax: "Tax id 13 digits",
      taxid_nidn: "ID card number 13 digits",
      taxid_ccpt: "Passport number",
      address: "Address",
      address_no: "No",
      address_road: "road",
      address_sub_district: "Sub district",
      address_district: "District",
      address_province: "Province",
      address_postal_code: "Postal code",
      address_telephone: "Telephone",
      address_tel: "Tel",
      address_name_contact: "Name contact",
      hint_address: "Number, building, street",
      email: "Email",
      headOffice: "Head Office",
      otherBranches: "Other Branches",
      note:
        "Note: Mak like for this document to be delivered directly to the target and more than 1 check mark to the device, between the pages",
      rules_businessType: "Please select a business type",
      rules_buyerName: "Please enter Buyer Name",
      rules_businessType: "Please enter Branch",
      rules_branch: "Please enter Branch",
      rules_taxid: "Please enter Tax ID",
      rules_numberFix: "Must be at least 13 digits",
      rules_numberFixbranch: "Must be 5 digits",
      invalid_email_format: "Invalid email format",
      address_building: "Building",
      address_alley: "Soi",
      address_floor_number: "Floor No.",
      address_moo_number: "Village No.",
      address_room_number: "Room No.",
      address_village: "Village",
      pleaseBranchId: "Specify branch",
      detail: "More Detail"
    },
    detail: {
      doc_found: "Number of documents found :"
    },
    table: {
      header_no: "No.",
      header_detail: "Detail",
      header_amount: "Amount",
      header_price: "Price / unit (baht)",
      header_discount: "Discount (baht)",
      header_listdiscountItem: [
        { value: "baht", text: "baht" },
        { value: "percent", text: "%" }
      ],
      header_vat: "Vat",
      header_total_price: "Total price (baht)",
      body_product: "Product / Service",
      body_listvatItem: [{ value: 0, text: "0%" }, { value: 7, text: "7%" }]
    },
    dowloadind_data: "Downloading data ...",
    swal: {
      server_err:
        "The system is currently unavailable. Please contact the administrator",
      data_download_err: "Downloading takes a long time.",
      notify_download_excel: "Did you need to download?",
      no_data: "No data found in the system.",
      notify_taxid: "Please fill in the information 'Tax ID'",
      notify_buyer: "Please fill in the information 'Buyer name'",
      notify_invoicename: "Please fill in the information 'Document id'",
      notify_issue_date: "Please fill in the information 'Issue date'",
      notify_delete_product:
        "Unable to delete less than one 'Product/Service Item'.",
      notify_fill_information: "Please fill out the required fields",
      notify_confirm_document: "Confirm document preview",
      notify_save_document: "Did you save the last document?",
      mistake: "Mistake",
      cannot_download_tem: "Unable to load Template",
      full_requrie:
        "Please check that the information is correct and meets the requirements.",
      save_success: "The document was saved successfully.",
      reason_delete: "Please enter the reason for deletion of document.",
      saveDraf: "Successfully saved draft",
      no_juristic_person: "Because the data is not a legal entity.",
      dateAlert:
        "In the case where the date of the document is specified in the past/advance Please always check the continuity of the document number before making a transaction!!"
    },
         mallType: [
        {
          text: "CENTRAL",
          value: "CENTRAL",
          image: require("@/assets/img/bill/central.svg"),
        },
        {
          text: "MAKRO",
          value: "MAKRO",
          image: require("@/assets/img/bill/mackro.svg"),
        },
        {
          text: "LOTUS’S",
          value: "LOTUS",
          image: require("@/assets/img/bill/lotus.svg"),
        },
        {
          text: "General Recipient",
          value: "OTHER",
          image: require("@/assets/img/bill/other.png"),
        },
      ],
      salesType: [
        { text: "Consignment Sale", value: "CSMT" },
        { text: "Credit Sale", value: "CRED" },
      ],
      salesTypeCPAll: [
        { text: "Debt Deduction on Delivery Date", value: "Now" },
        { text: "Debt Deduction After Delivery Date", value: "After" },
      ],
  },
  edit_invoice: {
    title: "Edit invoice",
    button_edit: "Save edit",
    button_preview: "Preview",
    condition: {
      title: "General information",
      sub_title: "Invoice information",
      button_add_product: "Add products / services",
      button_vat: "Withholding tax",
      button_add_receiving: "Add a receiving account",
      button_upload_file: "Upload files",
      button_preview_pdf: "Preview PDF",
      button_save: "Save as a draft",
      button_send: "Send invoice",
      condition_buyer_name: "Buyer name",
      condition_branchid: "Branch id",
      condition_taxid: "Tax id",
      condition_address: "Address",
      condition_address_no: "No",
      condition_address_road: "road",
      condition_address_sub_district: "Sub district",
      condition_address_district: "District",
      condition_address_province: "Province",
      condition_address_postal_code: "Postal code",
      condition_address_tel: "Tel",
      condition_address_name_contact: "Name contact",
      condition_invoice_id: "Invoice id",
      condition_required: "* Required",
      condition_issue_date: "Document date",
      rule_issue_date: "Pleace select Issue date",
      condition_doc_id: "Document id",
      condition_doc_type: "Document type",
      condition_example: "Example: monthly fee",
      condition_listproduct: "Product / Service List",
      condition_listproductItem: [
        { value: "0", text: "Separate tax" },
        { value: "1", text: "Tax included" }
      ],
      condition_close_dialog: "Close",
      condition_locale: "EN",
      condition_total_money: "Total money",
      condition_discount_included: "Discount included",
      condition_price_discount: "Price after discount",
      condition_value_without_tax: "Value without tax / exemption",
      condition_taxable: "Taxable value",
      condition_vat: "7% VAT",
      condition_total_sum: "Total sum",
      condition_payment_channel: "Payment channel",
      condition_additional_information: "Additional information",
      condition_additional_notes: "Additional Notes",
      condition_more_options: "More options",
      condition_barcode_bank: "Barcode bank payment",
      condition_without_tax: "Withholding",
      condition_amount_paid: "Amount to be paid",
      condition_attachment: "Attachment",
      condition_uploaded_file:
        "The uploaded file must not exceed 5 MB in size.",
      condition_tooltip:
        "If your receiving account has a Bill Paymenyt with the bank. ",
      condition_sub_tooltip:
        "You can turn on this function to generate barcodes for payments into PDFs."
    },
    dialog: {
      title: "Add a payment method",
      account_type: "Account type",
      listaccountItem: [
        { value: "promptpay", text: "Scan QR through PromptPay account." },
        { value: "bank", text: "Bank transfer" }
        // {value: 'pay', text: 'Pay by check or cash.'},
      ],
      bankItems: [
        {
          value: "kk",
          name: "Kiatnakin Bank",
          image: require("@/assets/img/icon-bank/kiatnakin.png")
        },
        {
          value: "scb",
          name: "Siam Commercial Bank",
          image: require("@/assets/img/icon-bank/scb.png")
        },
        {
          value: "kbank",
          name: "Kasikorn Bank",
          image: require("@/assets/img/icon-bank/kbank.png")
        },
        {
          value: "ktb",
          name: "Krung Thai Bank",
          image: require("@/assets/img/icon-bank/krungthai.png")
        },
        {
          value: "bbl",
          name: "Bangkok Bank",
          image: require("@/assets/img/icon-bank/bangkok.png")
        },
        {
          value: "bay",
          name: "Bank of Ayudhya ",
          image: require("@/assets/img/icon-bank/krungsri.png")
        },
        {
          value: "gsb",
          name: "Government Savings bank",
          image: require("@/assets/img/icon-bank/aomsin.png")
        },
        {
          value: "tbank",
          name: "Thanachart Bank ",
          image: require("@/assets/img/icon-bank/tnc.png")
        },
        {
          value: "tmb",
          name: "TMB Bank ",
          image: require("@/assets/img/icon-bank/tmb.png")
        },
        {
          value: "uob",
          name: "United Overseas Bank",
          image: require("@/assets/img/icon-bank/uob.png")
        },
        {
          value: "sme",
          name: "Small and Medium Enterprise Development Bank of Thailand",
          image: require("@/assets/img/icon-bank/unnamed.png")
        }
      ],
      sub_title:
        "The system will generate a QR Code and attach it to the bill that has been sent. Find customers through Email , allowing customers to scan for payment.",
      promptpay_number: "PromptPay number",
      account_name: "Account name",
      bank_name: "Bank",
      account_number: "Account number",
      explain: "For the item you wish to pay by check Or cash only",
      button_add: "Add",
      button_cancle: "Cancle"
    },
    detail: {
      doc_found: "Number of documents found :"
    },
    table: {
      header_no: "No.",
      header_detail: "Detail",
      header_amount: "Amount",
      header_price: "Price / unit (baht)",
      header_listdiscountItem: [
        { value: "baht", text: "baht" },
        { value: "percent", text: "%" }
      ],
      header_vat: "Vat",
      header_total_price: "Total price (baht)",
      body_product: "Product / Service",
      body_listvatItem: [{ value: 0, text: "0%" }, { value: 7, text: "7%" }]
    },
    dowloadind_data: "Downloading data ...",
    swal: {
      server_err:
        "The system is currently unavailable. Please contact the administrator",
      data_download_err: "Downloading takes a long time.",
      notify_download_excel: "Did you need to download?",
      no_data: "No data found in the system."
    }
  },
  view_invoice: {
    title: "View invoice",
    condition: {
      title: "General information",
      sub_title: "Invoice information",
      button_add_product: "Add products / services",
      button_vat: "Withholding tax",
      button_add_receiving: "Add a receiving account",
      button_upload_file: "Upload files",
      button_preview_pdf: "Preview PDF",
      button_save: "Save as a draft",
      button_send: "Send invoice",
      button_cancle: "Cancle",
      button_confirm: "Confirm",
      condition_buyer_name: "Buyer name",
      condition_branchid: "Branch id",
      condition_taxid: "Tax id",
      condition_address: "Address",
      condition_address_no: "No",
      condition_address_road: "road",
      condition_address_sub_district: "Sub district",
      condition_address_district: "District",
      condition_address_province: "Province",
      condition_address_postal_code: "Postal code",
      condition_address_tel: "Tel",
      condition_address_name_contact: "Name contact",
      condition_invoice_id: "Invoice id",
      condition_required: "* Required",
      condition_issue_date: "Issue date",
      rule_issue_date: "Pleace select Issue date",
      condition_doc_id: "Document id",
      condition_doc_type: "Document type",
      condition_example: "Example: monthly fee",
      condition_listproduct: "Product / Service List",
      condition_listproductItem: [
        { value: "0", text: "Separate tax" },
        { value: "1", text: "Tax included" }
      ],
      condition_close_dialog: "Close",
      condition_locale: "EN",
      condition_total_money: "Basis amount",
      condition_total: "Basis amount (Baht)",
      condition_discount_included: "Discount included",
      condition_price_discount: "Price after discount",
      condition_value_without_tax: "Value without tax / exemption",
      condition_taxable: "Tax basis total amount",
      condition_vat: "Tax total amount",
      condition_total_sum: "Grand total amount",
      condition_payment_channel: "Payment channel",
      condition_additional_information: "Additional information",
      condition_additional_notes: "Additional Notes",
      condition_more_options: "More options",
      condition_barcode_bank: "Barcode bank payment",
      condition_without_tax: "Withholding",
      condition_amount_paid: "Amount to be paid",
      condition_attachment: "Attachment",
      condition_uploaded_file:
        "The uploaded file must not exceed 5 MB in size.",
      condition_tooltip:
        "If your receiving account has a Bill Paymenyt with the bank. ",
      condition_edm: "Display message electronic document management",
      condition_sub_tooltip:
        "You can turn on this function to generate barcodes for payments into PDFs."
    },
    dialog: {
      title: "Add a payment method",
      account_type: "Account type",
      listaccountItem: [
        { value: "promptpay", text: "Scan QR through PromptPay account." },
        { value: "bank", text: "Bank transfer" }
      ],
      bankItems: [
        {
          value: "kk",
          name: "Kiatnakin Bank",
          image: require("@/assets/img/icon-bank/kiatnakin.png")
        },
        {
          value: "scb",
          name: "Siam Commercial Bank",
          image: require("@/assets/img/icon-bank/scb.png")
        },
        {
          value: "kbank",
          name: "Kasikorn Bank",
          image: require("@/assets/img/icon-bank/kbank.png")
        },
        {
          value: "ktb",
          name: "Krung Thai Bank",
          image: require("@/assets/img/icon-bank/krungthai.png")
        },
        {
          value: "bbl",
          name: "Bangkok Bank",
          image: require("@/assets/img/icon-bank/bangkok.png")
        },
        {
          value: "bay",
          name: "Bank of Ayudhya ",
          image: require("@/assets/img/icon-bank/krungsri.png")
        },
        {
          value: "gsb",
          name: "Government Savings bank",
          image: require("@/assets/img/icon-bank/aomsin.png")
        },
        {
          value: "tbank",
          name: "Thanachart Bank ",
          image: require("@/assets/img/icon-bank/tnc.png")
        },
        {
          value: "tmb",
          name: "TMB Bank ",
          image: require("@/assets/img/icon-bank/tmb.png")
        },
        {
          value: "uob",
          name: "United Overseas Bank",
          image: require("@/assets/img/icon-bank/uob.png")
        },
        {
          value: "sme",
          name: "Small and Medium Enterprise Development Bank of Thailand",
          image: require("@/assets/img/icon-bank/unnamed.png")
        }
      ],
      sub_title:
        "The system will generate a QR Code and attach it to the bill that has been sent. Find customers through Email , allowing customers to scan for payment.",
      promptpay_number: "PromptPay number",
      account_name: "Account name",
      bank_name: "Bank",
      account_number: "Account number",
      explain: "For the item you wish to pay by check Or cash only",
      button_add: "Add",
      button_cancle: "Cancle"
    },
    dialogBuyername: {
      title: "Buyer information",
      sub_title: "Buyer address",
      button_save: "Save",
      button_add: "Add buyer information",
      button_edit: "Edit buyer information",
      button_delete: "Delete buyer information",
      business_type: "Type of business",
      juristic_person: "Juristic person",
      guest: "Guest",
      buyer_name: "Buyer name",
      branchid: "Branch id",
      taxid: "Tax id",
      address: "Address",
      address_no: "No",
      address_road: "road",
      address_sub_district: "Sub district",
      address_district: "District",
      address_province: "Province",
      address_postal_code: "Postal code",
      address_telephone: "Telephone",
      address_tel: "Tel",
      address_name_contact: "Name contact",
      hint_address: "Number, building, street",
      email: "Email"
    },
    detail: {
      doc_found: "Number of documents found :"
    },
    table: {
      header_no: "No.",
      header_detail: "Detail",
      header_amount: "Amount",
      header_price: "Price / unit (baht)",
      header_discount: "Discount (baht)",
      header_listdiscountItem: [
        { value: "baht", text: "baht" },
        { value: "percent", text: "%" }
      ],
      header_vat: "Vat",
      header_total_price: "Total price (baht)",
      body_product: "Product / Service",
      body_listvatItem: [{ value: 0, text: "0%" }, { value: 7, text: "7%" }]
    },
    dowloadind_data: "Downloading data ...",
    swal: {
      server_err:
        "The system is currently unavailable. Please contact the administrator",
      data_download_err: "Downloading takes a long time.",
      notify_download_excel: "Did you need to download?",
      no_data: "No data found in the system.",
      notify_taxid: "Please fill in the information 'Tax ID'",
      notify_buyer:
        "Please fill in the information 'Buyer name and Buyer tax ID'",
      notify_invoicename: "Please fill in the information 'Document id'"
    }
  },
  settingsigning: {
    title: "Setting Position Signing",
    condition: {
      btn_add: "Add Position"
    },
    dialog: {
      copy_title: "Copy position",
      copy_sub_title: "you want to coppy position",
      copy_to: "to",
      delete_title: "Are you sure ?",
      delete_sub_title_1: "are you sure to delete",
      delete_sub_title_2: "from system"
    },
    table: {
      header_no: "No.",
      header_doc_type: "Document",
      header_position: "Position",
      header_user: "Usercode",
      header_active: "Active",
      header_action: "Action"
    },
    tools: {
      table: "Table",
      inputbox: "Input box",
      textfield: "Textfield",
      image: "Image",
      line: "Line",
      Rectangle: "Rectangle"
    }
  },
  addpositionsigning: {
    title: "Add Position Signing",
    edittitle: "Edit Position Signing",
    condition: {
      title_upload: "Click to upload file PDF",
      width: "Width",
      height: "Height",
      btn_upload: "Upload new file",
      btn_save: "Save",
      btn_accept: "Accept",
      btn_cancle: "Cancle",
      btn_edit: "Edit",
      btn_delete: "Delete",
      btn_copy: "Copy",
      btn_show: "On",
      btn_off: "Off"
    }
  },
  dialogEmail: {
    attachAdditionalFiles: "Attach Additional Files",
    attachFiles: "Click for attach additional files",
    email: "email",
    noteEtc: "Note: will attach additional file for every email item",
    ruleFiles: "The total File size should be less than 15 MB!",
    fileNotSupported: "Attaching additional files is not supported.",
    checkEmail: "Check email...",
    checkComplete: "Checking",
    checkFail: "Can't press send",
    checkSuccess: "Can press send",
    from: "out of",
    unit: "document",
    sendFileto: "You want to send files",
    btnSave: "Confirm",
    btnCancle: "Close",
    noEmail: "Email send history was not found for the selected document.",
    btnAddEmail: "Add email",
    resend: "again?",
    number: "Quantity",
    etc: "Note: You can use comma if you want to send more than one email.",
    note: "Note: Failed to check items will not be able to send email.",
    note1: "Please select a new item. to check again",
    close: "Close",
    sendSuccess: "Successfully sent email",
    success: "Success!",
    notfoundDoc: "The document was not found in the system",
    tokenTitle: "Token ONE Expires",
    tokenText: "Please log in again to get new token.",
    tokenBtnConfirm: "Log out",
    tokenBtnCancle: "Cancle",
    regex: "Invalid email format",
    listEmail: "Email send list",
    sendding: "Sending",
    senddingSuccess: "Success",
    senddingFails: "Fail",
    id: "Document ID",
    viewFile: "View details",
    hideFile: "Hide details",
    table: {
      no: "No.",
      documentId: "Document ID",
      resendMail: "Receiver",
      status: "Status",
      errorMessage: "Note.",
      doc_type: "Document type",
      buyer_name: "Buyer Name",
      file: "Additional attachment",
      nameFile: "Filename",
      size: "size"
    },
    btnSaveEmail: "Confirm",
    btnFile: "Add file",
    label_attachFileAll: "Attach additional all files",
    label_attachFileDispart: "Attach additional files by email",
    tabName: "Detail information",
    textDetailAttach: "Attached details",
    labelFileInput: "Click to select files"
  },
  dialogChat: {
    sendFileto: "You want to send files",
    btnSave: "Confirm",
    btnCancle: "Cancle",
    noOnechat: "Onechat send history was not found for the selected document.",
    btnAddOnechat: "Add phone number",
    resend: "again?",
    sendSuccess: "Successfully sent onechat",
    success: "Success!"
  },
  dialogSMS: {
    sendFileto: "You want to send files",
    btnSave: "Confirm",
    btnCancle: "Cancle",
    noSMS: "SMS send history was not found for the selected document.",
    btnAddSMS: "Add phone number",
    resend: "again?",
    sendSuccess: "Successfully sent email Onechat",
    success: "Success!",
    phoneNumber: "Phone Number",
    rulePhonenumber: "Please enter your Phone Number",
    fixPhonenumber: "Must be at least 10 digits"
  },
  dialogMailrelayCount: {
    no: "No.",
    read: "Reading time",
    detail: "Information",
    close: "Close"
  },
  dialogSftp: {
    downloading: "Downloading...",
    deleting: "Deleting document...",
    moving: "Moving documents...",
    deleteTitle: "Confirm deletion",
    deleteDetail: "You want to delete ",
    deleteAsk: " ?",
    deleteSuccess: "Delete success.",
    duplicateFile: "Duplicate files found ",
    replaceFile: "Would you like to replace that file?",
    duplicateNameFile: "Duplicate file/folder name",
    closeBtn: "Close",
    saveBtn: "Save",
    moveBtn: "Move",
    confirmBtn: "Confirm",
    cancleBtn: "Cancle",
    setting: "Setting",
    profile: "Profile",
    editPassword: "Edit password",
    passwordNow: "Current password",
    passwordNew: "New password",
    inputPasswordNow: "Please enter your current password.",
    inputPasswordNew: "Please enter a new password.",
    inputPasswordConfirm: "Confirm new password",
    PasswordCheck: "Please enter the same password.",
    hour: "Hour",
    minute: "Minute",
    excelBtn: "Set excel data",
    backBtn: "Back",
    addConfig: "Add config",
    editConfirm: "Confirm data correction",
    selectServiceCode: "Select Service code",
    selectConfig: "Select Service Config",
    checkConfigname: "Please enter config name",
    checkHour: "Please enter hour",
    checkMinute: "Please enter minute",
    checkServiceCode: "Please select service code",
    checkConfig: "Please select service config",
    checkUsercode: "Please enter usercode",
    checkAccesskey: "Please enter accesskey",
    checkEmail: "Please enter email",
    checkPassword: "Please enter password",
    checkPasswordConfirm: "Please confirm new password",
    uploadFile: "Upload files",
    uploadFileLabel: "File to upload",
    selectFile: "Please select the file you want to upload.",
    uploadFail: "File upload failed....",
    uploadFailDetail: "You can upload up to 100 files at a time.",
    uploadPending: "Waiting to upload",
    uploadProgress: "Uploading files...",
    uploadDone: "Successfully uploaded the file.",
    fileNotAccept: "File not supported",
    fileCatch: "The file cannot be uploaded at this time.",
    uploadFolder: "Create folder",
    checkFolder: "Please enter a folder name.",
    duplicateFolder: "This folder already exists.",
    settingExcelColRow: "Set columns/rows of data.",
    settingExcelTypedoc: "Document format:",
    settingExcelTypedocLabel: "Choose a document format.",
    settingExcelCategory: "Document type:",
    settingExcelCategoryLabel: "Select a document type.",
    settingExcelDetails: "Setting details:",
    settingExcelDetails1:
      "Columns: letters A-Z , rows: integer numbers 1-999...",
    settingExcelSeller: "Seller information :",
    settingExcelTypeinput: "Data type",
    settingExcelInputDetail: "Columns and rows",
    settingExcelDoc: "Document information :",
    settingExcelBuyer: "Buyer Information :",
    settingExcelLineitem: "Item information :",
    settingExcelSUMMARY: "Product Summary :",
    settingExcelRequird: "Please fill out all required fields.",
    settingColRow: "Set columns/rows of data."
  },
  sftpSetting: {
    setting: "Settings",
    account: "Personal information",
    settingConfig: "Config Settings",
    editPassword: "Edit Password",
    cancle: "Cancel",
    save: "Save",
    confirm: "confirm",
    confirmData: " Confirm data change",
    passwordNow: "Current password",
    passwordNew: "New password",
    placeholderPassword: "Please enter your password",
    placeholderPasswordNow: "Please enter your current password",
    placeholderPasswordNew: "Please enter a new password",
    placeholderconfirmPassword: "Confirm Password",
    selectServiceCode: "Select Service code",
    ruleconfigName: "Please enter Config name",
    rulepathInput: "Please select a Path input",
    rulepathOutput: "Please select Path output",
    ruleHour: "Please enter hour",
    ruleMin: "Please enter minutes",
    ruleServiceCode: "Please select Service code",
    ruleServiceConfig: "Please select Service config",
    ruleUsercode: "Please enter Usercode",
    ruleAccesskey: "Please enter Accesskey",
    ruleEmail: "Please enter your Email",
    ruleConfirmpass: "Please enter confirmation password",
    samePassword: "Please enter the same password",
    addConfig: "Add Config",
    nameConfig: "Name Config",
    status: "status",
    manage: "manage",
    nameSetting: "Setting name",
    dutyCycle: "dutyCycle",
    each: "every",
    hour: "hour",
    min: "minute",
    importDataFormat: "Import Data Format",
    settingExcel: "set excel data",
    back: "back",
    itemsServiceCode: [
      { value: null, text: "Select Service code" },
      { value: "S03", text: "S03 - CSV " },
      { value: "S06", text: "S06 - CSV and PDF" },
      { value: "S11", text: "S11 - CSV without sending e-mail" },
      { value: "E06", text: "EXCEL(Template) - Excel Format Template" },
      { value: "S46", text: "S46 - CSV by double-checking the document" }
    ],
    table: {
      nameConfig: "Name Config",
      status: "status",
      manage: "manage"
    },
    swal: {
      deleteTitle: "Confirm Delete",
      deleteSub: "You want to delete Config:",
      orNot: "or not"
    }
  },
  sftpIndex: {
    setting: "Settings",
    logout: "Logout",
    download: "Download",
    delete: "Delete",
    move: "Move",
    confirm: "Confirm",
    cancle: "Cancel",
    search: "Search for file/folder name",
    fileUpload: "Paste files for upload",
    duplicateFile: "Duplicate file found",
    selectFile: "Please select the file you want to replace.",
    selectAll: "Select All",
    cross: "cross",
    instead: "Replace",
    deleteDocument: "Deleting document... ",
    generateFile: "Generate file...",
    uploading: "Uploading..",
    selectServiceCode: "Select Service code",
    dowloadingFile: "Downloading file",
    selected: "Selected",
    waitingUpload: "Waiting for upload",
    uploadingFile: "Uploading file",
    uploadComplete: "File upload completed",
    uploadSuccess: "File uploaded successfully",
    fileNotSupported: "File not supported",
    serverErr: "Unable to connect to the server.",
    configS06:
      "Since the Config is S06, please upload the file according to the config. Supported files are (.pdf, .txt, .csv)",
    becauseConfig: "Because Config is",
    uploadConfigTxt:
      "Please upload the file according to the config. Supported files are (.txt, .csv)",
    uploadConfigXlsx:
      " Please upload the file according to the config. Supported files are (.xlsx,xls)",
    cannotUpload500: "Unable to upload files larger than 500MB",
    table: {
      fileName: "file/folder name",
      owner: "owner",
      lastdtm: "upload date",
      size: "size",
      action: "Manage Files"
    },
    swal: {
      generateSuccess: "Generate e-Tax succeeded",
      confirmDelete: "Confirm Delete",
      wantDeleteFile: "You want to delete a number of files.",
      list: "List or not",
      deleteSuccess: "Document entry successfully deleted",
      uploadFail: "File upload failed...",
      uploadFile: "You can upload up to 100 files at a time."
    }
  },
  sftpLogin: {
    noAccount: "Don't have an account yet?",
    register: "Register",
    forgerPassword: "Forgot your password?",
    login: "Login",
    confirm: "confirm",
    cancle: "Cancel",
    otpEmail:
      "*** OTP is sent to the email registered with the SFTP system and is valid for 15 minutes.",
    requestOtp: "Request OTP",
    settingPassword: "Set new password",
    placeholderPassword: "Please enter your password",
    placeholderPasswordAgain: "Please enter your password again",
    success: "Success",
    fail: "Failed",
    loginSuccess: "Login Successfully",
    server_err: "Unable to connect to server",
    passwordSame: "Please enter the same password",
    pleaseFillOut: "Please fill out",
    usernameReset: "Username to reset password",
    changePassword: "Password changed successfully.",
    swalTitle: "OTP verification is required to change new password.",
    swalSubTitle:
      "(Note: OTP will be sent to email previously registered with SFTP-FTP)",
    rules_username: "Please enter Username",
    rules_password: "Please enter Password",
    rules_otp: "Please enter OTP"
  },
  sftpRegister: {
    registerSftp: "Sign up for SFTP-FTP",
    note:
      "NOTE: The accesskey can be found in the documentation for connecting to the Service provided by INET.",
    back: "back",
    register: "Register",
    rules_username: "Please enter Username",
    rules_password: "Please enter Password",
    rules_usercode: "Please enter usercode",
    rules_name: "Please enter a name",
    rules_lastname: "Please enter your last name",
    rules_email: "Please enter your email ",
    rules_tel: "Please enter your phone number",
    rules_accessKey: "Please enter an accessKey",
    rules_fixPhone: "Please enter 10 digit phone number",
    formatEmail: "Invalid email format"
  },
  systemMaintenance: {
    title: "Sorry for the inconvenience."
  },
  dialogMailrelayCount: {
    no: "No.",
    date: "Opening date",
    tiem: "Opening time",
    detail: "E-mail opening details",
    close: "Close"
  },
  running_number: {
    title: "Create Document Number Format",
    title_add: "Create Document Number Format",
    title_edit: "Edit Document Number Format",
    note:
      "Note: Set the number of Digit numbers to be used to generate numbers, for example 00001",
    btn_create_form: "Create a form",
    condition: {
      title: "Search",
      btn_edit: "Edit data",
      btn_delete: "Delete data",
      btn_cancle: "Cancel",
      btn_save: "Save",
      condition_doctype: "Document Type",
      condition_ruleDoctype: "Please enter a document type",
      condition_ruleText: "Please enter text/symbol",
      condition_ruleRunningNum: "Please enter Running Number",
      condition_numType: "number format",
      condition_example: "Example",
      condition_text: "Text/symbol",
      condition_date: "Date",
      condition_month: "Month",
      condition_year: "Year",
      condition_type: "Format",
      condition_message: "Message"
    },
    table: {
      header_no: "Sequence",
      header_doc_type: "Document Type",
      header_form_id: "Form number",
      header_creater_name: "Creator Name",
      header_create_dtm: "Create date",
      header_using: "Using",
      header_action: "Action"
    },
    dowloadind_data: "Downloading data...",
    swal: {
      save_success: "Save data successfully",
      server_err: "Failed to save data",
      select_documents: "Please select a document type.",
      select_runningNumber: "Please select Running Number",
      notify_creat_form: "The form has been successfully created.",
      delete_success: "Delete data successfully",
      notify_select_running_number: "Please select a running number format"
    }
  },
  openApi: {
    invoice: "Tax Invoice",
    receipt: "Receipt",
    cash: "Receipt / Tax Invoice (cash)",
    login: "Logging in Open API ...",
    listItem: [
      { text: "Tax Invoice", value: "tax-invoices" },
      { text: "Receipts", value: "receipts" },
      { text: "Cash Invoice", value: "cash-invoices" },
      { text: "Invoice", value: "billing-notes" }
    ],
    condition: {
      title: "Condition",
      detail_doc_date: "Dated document is the date specified in the document",
      detail_from_date:
        "Date of submission is the date the document is entered into the etax system",
      button_search: "Search",
      button_cler: "Clear",
      button_download: "Download",
      button_download_all: "All Document",
      button_download_aselect: "Selected Document",
      button_create_etax: "Create E-tax",
      condition_docid: "Document id",
      condition_todocid: "to",
      condition_doctype: "Document type",
      doctype_list: [
        { value: "", text: "All" },
        { value: "388", text: "Tax invoice" },
        { value: "T02", text: "Invoice/Tax invoice" },
        { value: "T03", text: "Bill/Tax invoice" },
        { value: "T04", text: "Delivery note/Tax invoice" },
        { value: "T01", text: "Bill" },
        { value: "T07", text: "Cancellation note" },
        { value: "T05", text: "ABB" },
        { value: "T06", text: "Receipt/Abbreviated Tax Invoice" },
        { value: "80", text: "Debit note" },
        { value: "81", text: "Credit note" },
        { value: "380", text: "Invoice" },
        { value: "383", text: "Dabit note" },
        { value: "381", text: "Credit note" },
        { value: "207", text: "Delivery Note" },
        { value: "325", text: "Performa Invoice" },
        { value: "623", text: "Forwarder’s Invoice" }
      ],
      condition_listdoc: "Document list",
      condition_listdocItem: [
        { value: "", text: "All" },
        { value: "0", text: "General" },
        { value: "1", text: "Cancle/Out instead" }
      ],
      condition_seller_branchid: "Seller branch id",
      condition_buyer_taxid: "Buyer tax id",
      condition_buyer_name: "Buyer name",
      condition_buyer_branchid: "Buyer branch id",
      condition_fromdate: "Process date",
      condition_todate: "to",
      condition_processhint: "Please select document date",
      condition_fromdatedoc: "Document date",
      condition_todatedoc: "to",
      condition_processhint_to: "Please select to document date ",
      condition_close_dialog: "Close",
      condition_locale: "EN",
      condition_fromemail: "Send date",
      condition_toemail: "to",
      condition_status_email: "Status Email",
      waiting_for_delivery: "waiting for send"
    },
    detail: {
      doc_found: "Document found :",
      pdf: "Document selected :"
    },
    table: {
      no: "No.",
      seller_branch: "Seller branch id",
      doc_type: "Document type",
      doc_id: "Document id",
      dueDate: "Due date",
      Document_date: "Document date",
      buyer: "Buyer",
      buyer_tax: "Tax id",
      buyer_name: "Name",
      buyer_branch: "Branch id",
      select_file: "Select file",
      resend_sms: "Send SMS",
      resend_onechat: "Send Onechat",
      resend_mail: "Send mail",
      resend_file: "Resend file",
      resend_mail_select: "Select",
      resend_mail_resend: "Resend",
      no_data: "No data"
    },
    swal: {
      server_err:
        "The system is currently unavailable. Please contact the administrator",
      data_download_err: "Downloading takes a long time.",
      specify: "Please specify conditions",
      title: "Documents date and documents date (to) "
    },
    dialog: {
      title: "Confirm E-tax creation",
      subTitle: "Options for sending e-tax files",
      sub_Title: "Option to send files was not selected.",
      messageSuccess: "E-tax generated successfully",
      messageSuccess1:
        "You can check the document at the document search menu.",
      table: {
        title: "E-tax generating list",
        no: "NO.",
        doc_id: "DOCUMENT ID",
        buyer_tax: "BUYER TAXID",
        buyer_name: "BUYER NAME",
        status: "STATUS",
        note: "NOTE",
        email: "Email",
        action: "Action",
        status_process: "PROCESS",
        note_1:
          "Note: You can check the documents that have been successfully generated E-Tax from the document menu.",
        process: "Process",
        error: "Fail",
        success: "Success",
        close: "Close"
      },
      btn_cancle: "Cancle",
      btn_save: "Save",
      title_list: "Enable the OPEN API system.",
      sub_title_list:
        "Please enter Usercode AccessKey to enable OPEN API system.",
      note:
        "** Usercode, AccessKey information can be found in the e-Tax service connection document."
    }
  },
  cancleEtax: {
    title: "Credit note",
    tab_one: "Credit note (Full credit note)",
    tab_two: "Credit note (Some credit note)",
    tab_three: "Full credit note (ABB)",
    title_list: "Enable the Create cancle document system.",
    sub_title_list:
      "Please enter Usercode AccessKey to enable Create cancle document system.",
    button_create_creditnote: "Create Credit Note",
    btn_download: "Download pdf",
    doctype_list_all: [
      { value: "", text: "All" },
      { value: "388", text: "Tax invoice" },
      { value: "T02", text: "Invoice/Tax invoice" },
      { value: "T03", text: "Bill/Tax invoice" },
      { value: "T04", text: "Delivery note/Tax invoice" },
      { value: "T06", text: "Receipt/Abbreviated Tax Invoice" }
    ],
    table: {
      title: "E-tax generating list",
      no: "NO.",
      doc_id: "DOCUMENT ID",
      buyer_tax: "BUYER TAXID",
      buyer_name: "BUYER NAME",
      status: "STATUS",
      note: "NOTE",
      status_process: "PROCESS",
      note_1:
        "Note: You can check the documents that have been successfully generated E-Tax from the document menu.",
      process: "Process",
      error: "Fail",
      success: "Success",
      close: "Close",
      fileName: "File name",
      new_doc_no: "Document ID(CN)"
    },
    swal: {
      specify: "Please specify conditions",
      title: "Document date or Process date was submitted. either",
      subTitle: "Please select information for generating E-tax.",
      textCNAgain:
      'The document has ever been for a full CN. \nDo you want to continue?',
    },
    condition: {
      condition_original_document_value: "Original document value",
      condition_correct_value: "Correct value",
      condition_difference: "Difference",
      condition_total_money: "Total", // รวมมูลค่า
      condition_discount_included: "Discount", // มูลค่าส่วนลด
      condition_amount_after_discount: "Amount after discount",
      condition_vat: "VAT", // มูลค่าภาษี
      condition_discount_excluded: "Price excludes VAT",
      condition_total_sum: "Total amount" // จำนวนเงินสุทธิ
    },
    buttom: {
      cancel: 'Cancel',
      continue: 'Continue',
    },
  },

  group_user: {
    title: "Data access schedule (Seller branch)",
    btn_create: "Create group access",
    note_delete: "You want to delete ",
    alert_create: "Create success",
    alert_catch: "Group settings are not available at this time.",
    alert_delete: "Group data has been deleted successfully.",
    alert_update: "Successfully edited.",
    alert_selectBranch: "Please select a Branch",
    alert_enableGroup: "Data access schedule (Seller branch) was enable",
    alert_disableGroup: "Data access schedule (Seller branch) was disable",
    title_enableGroup: "Data access schedule (Seller branch) was enable",
    title_disableGroup: "Data access schedule (Seller branch) was disable",
    dialog_load: "loading...",
    view_more: "View more",
    tips_edit: "Edit",
    tips_delete: "Delete",
    label_group_name: "Access group name",
    label_status: "Status",
    label_group_branch: "Access branch information",
    label_group_user: "Users with access to information",
    table_group_name: "Access group name",
    table_status: "Status",
    table_group_branch: "Access branch information",
    table_group_user: "Users with access to information",
    table_action: "Action",
    label_group_name_select: "Access group name (seller)"
  },
  landingpage_index: {
    title: "Electronic Tax Invoice",
    subTitle: "A new cost-saving solution for businesses of all sizes",
    detailSystemEtax:
      "etax.one.th system has been certified according to standard recommendations. From the Electronic Transactions Development Agency (ETDA) ETDA on information security for service providers to deliver and maintain electronic data (ask for TI 21-2019)",
    basicLevel: "Basic Level",
    switchEtax: "Switch to e-Tax Invoice today",
    issuingTax: "Issuing tax invoice",
    issuingReceipt: "Issuing Receipt",
    issueCredit: "Issue Credit Note, Credit Note",
    sendInfo: "Send information directly to the IRS",
    generateTax: "Automatically generate sales tax report",
    saveTime: "Save delivery time",
    reduceCost: "Reduce the cost of doing business",
    safeReliable: "100% safe and reliable",
    detailEtax:
      "Service system for preparing and submitting electronic tax invoices and electronic receipts The entrepreneurs must prepare tax invoices, debit notes, credit notes and receipts in the form of electronic data with digital signatures that are secure and are of international standards. and submit the information to the Revenue Department Electronic tax invoices issued through the e-Tax Invoice & e-Receipt system are the legally valid standard where the electronic certificate number must be specified. And the digital signature is the identity of the tax invoice issuer (seller) and ensures the accuracy of the information.",
    detailEmail:
      "Suitable for small VAT registrants with income not more than 30 million baht per year. A small number of tax invoices have been issued. There is no large systematic document management. and may not be ready to issue complete electronic tax invoices as prescribed by the Revenue Department through the central system of OBEC The procedure is not difficult. The VAT registrant prepares, delivers and maintains electronic tax invoices via email. By the time stamp and the system will send that data file to buyers and sellers to store or use as evidence of the transaction."
  },
  createCancleInstead: {
    title: "Cancle document",
    condition: {
      title: "Condition",
      button_search: "Search",
      button_cler: "Clear",
      button_excel: "Export EXCEL",
      button_download: "Download",
      button_download_all: "All Document",
      button_download_aselect: "Selected Document",
      detail_doc_date: "Dated document is the date specified in the document",
      detail_from_date:
        "Date of submission is the date the document is entered into the etax system",
      condition_docid: "Document id",
      condition_todocid: "to",
      condition_doctype: "Document type",
      condition_date_pressing: "Date of pressing send email again",
      button_xml: "Generate credit note with XML file",
      notFound_runnumber: "No automatic document id setting.",
      document_manual: "Document id",
      runnumber: "Auto run Document id",
      runmanual: "Manual fill Document id",
      fill_documentID: "Please enter the document number.",
      doctype_list: [
        { value: "", text: "All" },
        { value: "388", text: "Tax invoice" },
        { value: "T02", text: "Invoice/Tax invoice" },
        { value: "T03", text: "Bill/Tax invoice" },
        { value: "T04", text: "Delivery note/Tax invoice" },
        { value: "T01", text: "Bill" },
        { value: "T07", text: "Cancellation note" },
        { value: "T05", text: "ABB" },
        { value: "T06", text: "Receipt/Abbreviated Tax Invoice" },
        { value: "80", text: "Debit note" },
        { value: "81", text: "Credit note" },
        { value: "380", text: "Invoice" },
        { value: "383", text: "Dabit note" },
        { value: "381", text: "Credit note" },
        { value: "207", text: "Delivery Note" },
        { value: "325", text: "Performa Invoice" },
        { value: "623", text: "Forwarder’s Invoice" }
      ],
      numberType: [
        { value: "invoice_number", text: "Invoice number" },
        { value: "running_number", text: "Running number" }
      ],
      condition_seller_branchid: "Seller branch id",
      condition_numberType: "Document number type",
      condition_fromdate: "Process date",
      condition_todate: "to",
      condition_processhint: "Please select document date",
      condition_fromdatedoc: "Document date",
      condition_todatedoc: "to",
      condition_close_dialog: "Close",
      condition_locale: "EN",
      rulesReason: "Specify reasons for creating credit note"
    },
    detail: {
      doc_found: "Document found :",
      pdf: "PDF selected :",
      xml: "XML selected :"
    },
    table: {
      no: "No.",
      doc_id: "Doucument id",
      document_type: "Doucument type",
      process_date: "Process date",
      document_date: "Document date",
      reportinstead_id: "Original Document Number",
      reportinstead_date: "Original document date",
      taxid: "Tax id (Buyer)",
      buyer_name: "Buyer name",
      buyer_branch: "Buyer branch id",
      action: "Action",
      no_data: "No data"
    },
    dialog_email: {
      noemail_text1: "No email for sending file.",
      noemail_text2: "Enter an email",
      noemail_text3: "Need to add an email?",
      noemail_input: "Email",
      havemail_text1: "Send the file to",
      havemail_text2: "once again?",
      havemail_text3: "Email sent last time",
      havemail_text4: "Email in Database",
      havemail_text5: "New Email",
      havemail_input: "Email",
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      loading: "Resendding...",
      complete: "Complete",
      btn_confirm: "Confirm",
      btn_edit: "Edit email",
      btn_add: "Add email"
    },
    dialog_download: {
      accesskey_text1: "Enter an accesskey",
      accesskey_text2: "Note: accesskey expires in 15 minute",
      notify_text1: "Downloading takes a long time. ",
      notify_text2: "Did you need to download?",
      btn_confirm: "Confirm",
      loading_download: "Downloading..."
    },
    swal: {
      server_err:
        "The system is currently unavailable. Please contact the administrator",
      accesskey_err: "Accesskey is incorrect",
      download_err: "Could not download files",
      morefile_err: "Document have more than 1 file",
      data_download_err: "Downloading takes a long time.",
      notify_download_excel: "Did you need to download?",
      notify_email_err:
        "The document was not found in the system. used for sending duplicate emails",
      title_token: "Token ONE Expires",
      subtitle_token: "Please login again to refresh the token",
      btn_cancle: "Cancle",
      btn_logout: "Logout",
      selectXml: "Select XML file",
      selectXml_label: "Please select an XML file.",
      titlePropose: "Document cancellation reason",
      title_Propose: "Credit cancellation reason",
      titleProposeInput: "Input reason",
    },
    itemProposeCode: [
      { text: "Discount on sold products (Products not meeting agreed conditions)", value: "CDNG01" },
      { text: "Damaged or defective products", value: "CDNG02" },
      { text: "Shortage of products as agreed in the purchase", value: "CDNG03" },
      { text: "Pricing error higher than the actual price", value: "CDNG04" },
      { text: "Return of goods (Not as described)", value: "CDNG05" },
      //{ text: "Other reasons (Specify the reason)", value: "CDNG99" },
      { text: "Discount on service fees (Services not meeting agreed conditions)", value: "CDNS01" },
      { text: "Shortage in service quantity", value: "CDNS02" },
      { text: "Pricing error in service fees higher than the actual price", value: "CDNS03" },
      { text: "Termination of service contract", value: "CDNS04" },
      { text: "Other reasons (Specify the reason)", value: "CDNS99" },
    ],
  },
  editTaxinvoice: {
    btnCreateXml: "Edit tax invoice with xml file",
    detailEdit: "Detail Editing Information",
    buyerInfo: "Detail editing info",
    btnEdit: "Edit",
    dataNotFound: "Data not found",
    detail: "Detail",
    close: "Close",
    dialogConfirm: {
      title: "Activate the system ",
      subTitle: "Please enter Usercode and AccessKey to activate",
      detailSubTitle: "System"
    },
    dialogEditTaxinvoice: {
      pleaseEnter: "Enter manually",
      typeResend: "Resend Send Format",
      buyerId: "Buyer Id",
      buyerName: "Buyer Name",
      consigneeCode: "Consignee Code",
      consigneeName: "Consignee Name",
      issueAssignedId: "Order Reference",
      issueAssignedIdOth: "Purchase order number",
      buyerEmail: "Buyer Email",
      lineOne: "Buyer Address Line 1",
      lineTwo: "Buyer Address Line 2",
      lineThree: "Buyer Address Line 3",
      postcode: "Postal Code",
      countryId: "Country Code",
      phoneBranch:
        "The telephone number of the branch that issued the tax invoice",
      totalPieces: "Seller department",
      dataDocument: "Document Data",
      documentId: "Document number",
      documentType: "Document type",
      ruleDocumentId: "Please enter document number",
      documentDate: "Document date",
      ruleDoumentDate: "Please select a dated document",
      ruleCountryID: "Please specify country code",
      rulePostCode: "Please specify postal code",
      purpose: "Reason for Debt Reduction Code",
      rulePurpose: "Please enter reason code for debt reduction",
      documentName: "Document Name",
      ruleDocumentName: "Document Name",
      taxid: "taxpayer identification number",
      ruleTaxid: "Please enter taxpayer identification number",
      additionalRefIssuerAssignedID: "Ref No.",
      additionalRefIssueDateTime: "Ref Date",
      ruleAdditionalRefIssueDateTime: "Please select a reference date",
      branchId: "Branch number",
      ruleBranchId: "Please enter branch number",
      documentRemark2: "Reference e-Credit Voucher",
      flexfield: "Reason for reducing debt",
      documentRemark: "IMPORTANT NEWS PLEASE READ",
      documentRemark1: "PV order amount",
      documentRemarkBV: "Order amount BV",
      documentRemark3: "Personal Balance|Group PV Balance or Amplus PV Points",
      documentRemark4: "Personal Balance|Group BV Balance or BV Amplus Points",
      documentRemark5: "Details at the end of product table 1",
      documentRemark8: "Details at the end of product table 2",
      documentRemark9: "Details at the end of product table 3",
      documentRemark10: "Details at the end of product table 4",
      payee: "Payee - Payee Date",
      newIssue: "In case of a new issue instead of the original one",
      newPurpose: "Purpose to reissue the original one",
      btnNext: "Next",
      btnCancle: "Cancel",
      btnBack: "Back",
      btnPreview: "Preview",
      selectServiceCode: "Select Servicecode",
      selectPDF: "Select PDF file",
      supportPDFOnly: "Support PDF files only",
      newPurposetoOld: "Reason for issuing a new one instead of the old one",
      newPurposeCodetoOld:
        "Reasonation code for issuing a new certificate instead of the original one",
      additionalRefIssueTypecode: "Ref Document Type",
      buyerTaxid: "Buyer Tax Identification Number",
      ruleBuyerTaxid: "Please enter buyer's tax identification number",
      buyerBranchId: "Buyer Branch Number",
      ruleBuyerBranchId: "Please enter buyer branch number",
      buyerOrderReferencedDocument: "Order Reference",
      orderIssueDateTime: "Order Reference Date",
      ruleBuyerName: "Please enter buyer name",
      ruleDocumentNumber: "Please enter reference document number",
      rulePropose: "Please select an exit reason code instead.",
      rulePropose99:
        "Please specify the reason for issuing a new one to replace the old one.",
      business_type: "Type of business",
      guest: "Guest",
      title_buyer_info: "Buyer information",
      passport: "Passport",
      juristic_person: "Juristic person",
      other: "Other",
      totalOfPieces: "Total of pieces",
      pdftitle: "PDF upload option",
      pdfSubTitle:
        "Upload a PDF file if you want to create a document with an existing PDF file.",
      dropFole: "Drag and drop files here or click to upload files.",
      upload: "Upload",
      view: "View",
      close: "Close"
    },
    swal: {
      warning: "Warning",
      requird: "Please provide complete information",
      autorunFail: "Autorun numbers are not available.",
      formatEmail: "Invalid email format",
      uploadPdfOne: "You can upload up to one file at a time.",
      fileAccept: "Only PDF files are supported.",
      fileXmlAccept: "Only XML files are supported.",
      sendmail: "Please enter buyer's email information to use email delivery"
    }
  },
  revenue_status: {
    swalSearchTitle: "Please specify conditions",
    swalSearchSubtitle:
      "Documents dated, Process date, Revenue submission date either"
  },
  sftpList: {
    title: "document certification system",
    condition: {
      statusDoc: "Document status",
      dataType: "Data Type",
      seller_branch: "Seller branch",
      documentName: "Document file Name",
      file_create: "file create date",
      file_to: "To",
      file_found: "Files found :",
      name: "Fullname",
      tel: "Telephone Number",
      email: "Email",
      position: "Position",
      infor: "Account information",
      buyer_taxid: "Buyer tax id",
      contract_number: "Contract number",
      file: "Files",
      delete_title: "Are you sure ?",
      delete_sub_title: "Are you sure to reject",
      reject_title: "Confirm document cancellation",
      reject_or: "Yes or no?",
      reject_sub_titile: "Cancel document ",
      reject_success: " Success",
      btnCancel: "Cancel",
      fromdatedoc: "Document date",
      select_reject: "Select the item you want to reject",
      num_doc: "Number of rejected ",
      list: "List",
      btn_confirm: "Confirm",
      btnBack: "Back",
      confirm_tran: "Confirm the transaction",
      fromdate: "Process date",
      trans_date: "Transaction date",
      trans_per: "Transaction person",
      doctype_list: [
        { value: "", text: "All" },
        { value: "380", text: "Invoice" },
        { value: "388", text: "Tax invoice" },
        { value: "T03", text: "Invoice/Tax invoice" },
        { value: "T01", text: "Bill" },
        { value: "80", text: "Debit note" },
        { value: "81", text: "Credit note" }
      ],
      item_batchType: [
        { value: "eTax", text: "eTax" },
        { value: "eBill", text: "eBill" }
      ]
    },
    table: {
      file_name: "Document file name",
      file_create: "File create date",
      file_status: "Document status",
      doc_All: "All documents",
      doc_confrim: "Approved documents",
      doc_cancle: "Rejected documents",
      approver: "Approver",
      date_approver: "Approval date",
      doc_list: "View document",
      doc_reject: "Reject file",
      status: "Status",
      customer_name: "Customer name",
      details: "Details"
    },
    status: {
      count_approve: "Approve",
      count_pending: "Pending",
      count_docAll: "All",
      approve: "Approve",
      reject: "Reject",
      registering: "Registering",
      pending: "waiting",
      fail: "Batch file no pass",
      count_doc_pending: "Pending",
      count_doc_reject: "Reject",
      count_doc_approve: "Approve",
      chip_success: "Success",
      chip_fail: "Fail",
      chip_pc: "Process",
      pending_detail: "Pending",
      approve_detail: "Approve",
      pc: "Process"
    },
    swal: {
      specify: "Please specify all conditions as required.",
      cancleSuccess: "Cancel file successfully",
      confirm_success:
        "System is processing. You can check the document status later.",
      success: "Success",
      process:
        "The system is generating the document. able to check the status later"
    },
    require: {
      date: "Please specify the date",
      todate: "Please specify to date",
      type: "Please specify data type",
      docStatus: "Please specify document status"
    }
  },
  login: {
    credentials_fail: "Invalid username or password!! please try again",
    business_not:
      "Can't find a juristic person account or juristic person account is in the process of checking",
    denied_request: "can't log in Please try again.",
    success: "Login success"
  },
  approveDocument: {
    title: "Approve Document",
    buyer_address: {
      title_taxpayer_info: "Taxpayer Information",
      nameCompany: "Company/Name (Taxpayer name)",
      lableTaxid: "Type a Tax ID",
      address: "Address",
      buyer_branch: "Branch id",
      email: "Email",
      phone: "Phone"
    },
    seller_detail: {
      seller_info: "Seller information",
      seller_branch_id: "Seller branch id",
      document_type: "Doucument type",
      document_id: "Doucument id",
      document_id_ref: "Doucument id (Ref)",
      document_date: "Document date",
      document_date_ref: "Document date (Ref)",
      total_amount: "Total Amount",
      docTypeList: [
        { text: "Invoice", value: "380" },
        { text: "Tax invoice", value: "388" },
        { text: "Bill", value: "T01" },
        { text: "Invoice/Tax invoice", value: "T02" },
        { text: "Bill/Tax invoice", value: "T03" },
        { text: "Delivery note/Tax invoice", value: "T04" }
      ]
    },
    actions: {
      btnBack: "Back",
      btnReject: "Reject request",
      btnPreview: "Preview",
      btnCreate: "Create",
      searchAgain: "Search again"
    },
    dialog: {
      title_dialog: "Confirm document creation",
      btnBack: "Back",
      btnConfirm: "Confirm",
      btnCreate: "Create",
      error: "Error",
      errMsg: "The system cannot be used at this time",
      document_reject: "Document rejection",
      reasonReject: {
        document_id_found: "Document id not found",
        document_date_found: "Document date not found",
        document_total_amount_found: "Total Amount not found",
        document_other: "Other"
      }
    },
    condition_listproduct: "Product / Service List",
    condition_additional_end_notes_more:
      "Note at the end of the document ( more )",
    table: {
      no: "No.",
      document_id: "Doucument id",
      document_date: "Document date",
      buyer_taxid: "Tax id",
      process_dtm: "Document create date",
      status: "Status",
      error_message: "Document status details"
    },
    process_status_success: "Documents passed",
    process_status_reject: "Document fail",
    process_status_process: "Document processing",
    process_status_wait: "Documents waiting",
    vatType: "Product price",
    vatTypeItems: [
      { text: "Include vat", value: "Include" },
      { text: "Exclude vat", value: "Exclude" }
    ]
  },
  document_ref_group: {
    tiv: [
      { value: "388", text: "Tax invoice" },
      { value: "T02", text: "Invoice/Tax invoice" },
      { value: "T03", text: "Bill/Tax invoice" },
      { value: "T04", text: "Delivery note/Tax invoice" },
    ],
    abb: [
      { value: "T05", text: "ABB" },
      { value: "T06", text: "TAX INVOICE (ABB)" },
    ],
    rct: [{ value: "T01", text: "Bill" }],
    inv: [{ value: "380", text: "Invoice" }],
    cn: [{ value: "81", text: "Credit Note (Full amount)" }],
    dn: [{ value: "80", text: "Debit note" }],
  },
};



// WEBPACK FOOTER //
// ./src/translations/locales/en.js